import React from 'react'
import { observer } from 'mobx-react'
import { observable, action, reaction } from 'mobx'
import {
  Button,
  Row,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Image,
  Modal,
  ModalTitle,
} from 'react-bootstrap'
import isArray from 'lodash/isArray'
import { pageNames } from 'src/routes/pathParams'
import { Link } from 'react-router-dom'
import { LinkWithLocale, MetaDecorator } from 'src/views/components'
import { i18nTranslate } from 'src/utils'
import { Form } from 'react-bootstrap'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
//import { enUS, es, fr, vi, zhCN } from 'date-fns/locale'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import {
  customerContainer,
  cartContainer,
  subscriptionContainer,
  // checkoutContainer,
  loyaltyContainer,
  userContainer,
  storeContainer,
  catalogContainer,
} from 'src/models'
import {
  SubscriptionProductTile,
  // SubscriptionProgressBar,
  toastState,
  ServiceErrorUI,
  Icons,
  AccordionBlock,
  ConfirmationModal,
  modalState,
  overlayState,
} from 'src/views/components'
import {
  // fetchSubscriptionPreferenceList,
  dateFormatDeps,
  FormInputLabels,
  getFilterParams,
  checkIfCardIsExpired,
} from 'src/deps'
import { SubscriptionShippingDetailsView } from './SubscriptionShippingDetailsView'
import { ShowAllProductListView } from './ShowAllProductListView'
import { ProcessNowModal } from './ProcessNowModal'
import { sortingPvItem, transformShowAllResponse } from './deps'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import {
  application,
  convertToBoolean,
  // parseUTCDate,
  getConvertedMonth,
  getConvertedYear,
  currencyFormat,
  IS_BROWSER,
  getLocaleCodeFromUrl,
} from 'src/utils'

import SubscriptionInfiniteScroll from 'src/views/components/SubscriptionInfiniteScroll'
import ShowPvProductList from './ShowPvProductList'
import { getAppConfig } from 'config/appConfig'
import BundleView from './BundleView'
// import { SubscriptionsDeliveryStatus } from './SubscriptionsDeliveryStatus'
import { IoIosInformationCircleOutline as InformationIconOutline } from 'react-icons/io'
import SubscriptionProductTileLegacy from 'src/views/components/SubscriptionProductTile/SubscriptionProductTileLegacy'
import ShowAll from './ShowAll'
// import MobileSubscriptionsDeliveryStatus from './MobileSubscriptionsDeliveryStatus'
import { SubscriptionErrorNotification } from './SubscriptionErrorNotification'
import { ProductsPlaceHolder } from 'src/views/placeholders/ProductsPlaceHolder'
import { scrollUtilities } from 'src/utils/customScrollManager'
import './styles.scss'

@observer
class SubscriptionsView1 extends React.Component {
  @observable loyaltyPoints = {}
  @observable isDateChangeCallInProgress = false
  @observable processNowClicked = false
  @observable isToShowProcessNowModal = false
  @observable isDonationChecked = false
  @observable isDonationCallInProgress = false
  @observable openAccordion = true
  @observable enableConfirmation = false
  @observable showModal = false
  @observable showPvModal = false
  @observable selectedSkuID = ''
  @observable isCancelSubsCallInProgress = false
  @observable isDeleteAllCallInProgress = false
  @observable updatedMonthlyPv = 0
  @observable userList = []
  @observable selectedUser = {}
  @observable filteredOption = []
  @observable username = ''
  @observable noUsersFound = false
  @observable isBundleView = false
  @observable productId = ''
  @observable categoryId = ''
  @observable isTooltipEnabled = false
  @observable isInfoModalEnabled = false
  @observable isToShowMigrationModal = false
  @observable itemPriceCopy = 0
  @observable viewallTotal = 0
  @observable processingMonth = ''
  @observable legacySubscriptionItems = []
  @observable isDeleteModalEnabled = false
  isToEnableOneTimeFrequency =
    getAppConfig()?.oneTimeFrequencyEnabled === 'true'

  constructor(props) {
    super(props)
    subscriptionContainer.setIsPreferenceCallOver(false)
    subscriptionContainer.isPreferenceAPIInProgress = true
    subscriptionContainer.subscriptionPreferenceResponse = ''
    subscriptionContainer.showAllSubscriptionResponse = ''
    subscriptionContainer.selectedSubscription = ''
    subscriptionContainer.selectedMonth = ''
  }

  async componentDidMount() {
    this.invokeAPIsOnload()
    catalogContainer.catalogResponse = {}

    reaction(
      () => {
        return customerContainer.isRegisterUser
      },
      (isRegisterUser, reaction) => {
        isRegisterUser && this.getScanCardList()
        reaction.dispose() // reaction is disposed (reaction happens only once)
      }
    )
    const { enUS, es, fr, vi, zhCN } = await import('date-fns/locale')
    let usedLanguage = ''
    if (IS_BROWSER) {
      let locale = getLocaleCodeFromUrl() || ''
      locale = locale?.toLowerCase()?.split('_')

      usedLanguage =
        locale[0] === 'zh'
          ? zhCN
          : locale[0] === 'en'
            ? enUS
            : locale[0] === 'fr'
              ? fr
              : locale[0] === 'es'
                ? es
                : locale[0] === 'vi'
                  ? vi
                  : enUS
    }
    registerLocale(`${usedLanguage}`, usedLanguage)
    setDefaultLocale(usedLanguage)
    scrollUtilities.scrollToTop('my-account-details-wrapper')
  }

  invokeAPIsOnload = async () => {
    if (customerContainer.isRegisterUser)
      await cartContainer.getSubscriptionCount()
    await this.getSubscriptionResponse()
    let firstName = customerContainer.profileResponse?.firstName || ''
    let lastName = customerContainer.profileResponse?.lastName || ''
    this.username = firstName ? `${firstName + ' ' + lastName}` : ''
    this.getDonationStatus()
    // this.getLoyaltyPoints()
    this.getScanCardList()
    // this.checkLegacySubscriptions()
  }

  checkLegacySubscriptions = () => {
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    let legacyProducts = transformShowAllResponse(
      currentMonth,
      lastOrderProcessedMonth,
      lastSubscriptionOrderStatus,
      subscriptionContainer.showAllSubscriptionResponse,
      true
    ) // Taken showall response here, as subscriptions not available for current month
    // let legacyProducts = []
    // for (const selectedSubscription of showAllSubscriptionResponse) {
    //   const { subscriptions = [] } = selectedSubscription
    //   if (subscriptions.length > 0) {
    //     if (Array.isArray(subscriptions)) {
    //       legacyProducts = subscriptions.filter(
    //         sub => sub.enableItemLevelProcessing
    //       )
    //     }
    //   }
    // }
    // this.legacySubscriptionItems = legacyProducts
    return legacyProducts
  }

  getScanCardList = async () => {
    if (customerContainer.isRegisterUser) {
      await cartContainer.scanCardList()
    }
  }

  getLoyaltyPoints = async () => {
    this.loyaltyPoints = await loyaltyContainer.getLoyaltyPoints(true)
  }

  getDonationStatus = async () => {
    // await customerContainer.getProfile()
    this.isDonationChecked = convertToBoolean(
      customerContainer.profileResponse?.customProperties?.hasDonationRoundUp ||
        ''
    )
  }

  componentDidUpdate(prevProps) {
    this.checkAndUpdateComponent(prevProps)
  }

  checkAndUpdateComponent = async prevProps => {
    if (
      JSON.stringify(prevProps.location) !== JSON.stringify(this.props.location)
    ) {
      await this.getSubscriptionResponse()
    }
  }
  getPvAssistanceResponse = async () => {
    const response = await subscriptionContainer.getAllPvAssistProduct(
      customerContainer.userId
    )
    return response
  }
  customerUserIdCheck = async (month, showAll, showAllShippingmethodUpdate) => {
    const id = this.props.location?.queryParams?.id || ''
    if (
      subscriptionContainer.allUsers &&
      (id || this.selectedUser?.accountId)
    ) {
      const response =
        await subscriptionContainer.getAllSubscriptionsPreference(
          id ? id : this.selectedUser?.buyerInfo?.id,
          month,
          showAll,
          showAllShippingmethodUpdate
        )
    } else if (customerContainer.userId) {
      const response =
        await subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId,
          month,
          showAll,
          showAllShippingmethodUpdate
        )
      const minMonthlyPV = response?.order?.monthlyPV || '0'
      this.updatedMonthlyPv = minMonthlyPV
    } else {
      setTimeout(
        () =>
          this.customerUserIdCheck(month, showAll, showAllShippingmethodUpdate),
        500
      )
    }
  }
  getSubscriptionResponse = async showAllShippingmethodUpdate => {
    let month = this.props.location?.queryParams?.month || ''
    let showAll = false
    this.noUsersFound = false
    if (month == 'showall') {
      month = ''
      showAll = true
    } /* else if (month === 'pvassistant') {
      month = false
      showAll = false
    } */
    // EC-7479 - holds the current selected month, used to bold the selected month in "upcoming deliveries" section
    subscriptionContainer.selectedMonth = month ? parseInt(month) : month
    if (subscriptionContainer.allUsers) {
      const queryParams = getFilterParams(this.props.location || {})
      const params = {
        page: queryParams.page || 1,
        size: 50,
      }
      let users
      if (this.userList && this.userList.length == 0) {
        users = await userContainer.getUsersList(params)
        this.userList = users?.accountBuyer || []
        this.userList = this.userList.filter(
          ({ buyerInfo = {} }) =>
            buyerInfo.id !== customerContainer.userId &&
            buyerInfo.status === 'ACTIVE'
        )
        this.filteredOption = this.userList || []
      }
      if (this.userList && this.userList.length) {
        await this.customerUserIdCheck(
          month,
          showAll,
          showAllShippingmethodUpdate
        )
      } else {
        this.noUsersFound = true
        subscriptionContainer.isPreferenceAPIInProgress = false
      }
    } else {
      await this.customerUserIdCheck(
        month,
        showAll,
        showAllShippingmethodUpdate
      )
    }
  }

  handleBundleView = (productId, categoryId) => {
    this.productId = productId
    this.categoryId = categoryId
    this.isBundleView = !this.isBundleView
    this.isBundleView
      ? document.body.classList.add('no-scroll')
      : document.body.classList.remove('no-scroll')
  }

  patchSubscriptionDonation = async hasDonationRoundUp => {
    const postData = {
      hasDonationRoundUp: `${hasDonationRoundUp}`,
      donationProgramId: hasDonationRoundUp ? 1 : 0,
    }
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      postData
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
    }
  }
  renderPvModal = () => {
    this.showPvModal = !this.showPvModal
  }
  handleSkipItem = async (data, handleSkipDisableCondition) => {
    const { id, currentInstance, isSkippedSubscription } = data
    overlayState.toggleLoader()
    const response = await subscriptionContainer.skipSubscription({
      subscriptionId: id,
      isSkippedSubscription: isSkippedSubscription,
      currentInstance,
    })
    const orders =
      subscriptionContainer.subscriptionPreferenceResponse?.order || ''
    const isPvAssistantEnable =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistEnabled ||
      false
    const pvAssistGoal =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistGoal || '0'
    const minMonthlyPV = orders?.monthlyPV || '0'
    const pvDifference =
      minMonthlyPV - data?.itemInfo?.[0]?.properties?.pointValue
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      const successMessage = isSkippedSubscription
        ? i18nTranslate(
            'editSubscription.skipSubscribe',
            'Your upcoming or next month delivery has been skipped successfully'
          )
        : i18nTranslate(
            'editSubscription.unSkipSubscribe',
            'Your upcoming or next month delivery has been unskipped successfully'
          )
      const showPvModel = isPvAssistantEnable
        ? this.updatedMonthlyPv <= pvAssistGoal
          ? true
          : false
        : false
      toastState.setToastMessage(successMessage, true)
      isSkippedSubscription &&
        pvDifference != 0 &&
        showPvModel &&
        this.renderPvModal()
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.instance.unskip.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              ' This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    handleSkipDisableCondition && handleSkipDisableCondition()
  }
  handleItemProcessing = async (data, handleSkipDisableCondition) => {
    const { id, currentInstance, isSkippedSubscription } = data
    const response = await subscriptionContainer.handleItemProcessing({
      subscriptionId: id,
    })
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      const accountId = response?.accountId || ''
      if (accountId != '') {
        toastState.setToastMessage(
          i18nTranslate(
            'editSubscription.itemProcessed',
            'Your item has been processed.'
          ),
          true
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          ),
          false
        )
      }
    }

    handleSkipDisableCondition && handleSkipDisableCondition()
  }

  handleDonationCheck = async () => {
    this.isDonationCallInProgress = true
    this.isDonationChecked = !this.isDonationChecked
    await this.patchSubscriptionDonation(this.isDonationChecked)
    this.isDonationCallInProgress = false
  }

  onInputChange = event => {
    this.filteredOption = this.userList.filter(userObj => {
      const option = `${userObj?.buyerInfo?.firstName || ''} ${
        userObj?.buyerInfo?.lastName || ''
      }`.toLowerCase()
      return option.indexOf(event.target.value) > -1
    })
  }

  handleUserChange = user => {
    let month = this.props.location?.queryParams?.month || ''
    let showAll = false
    if (month == 'showall') {
      month = ''
      showAll = true
    }
    this.selectedUser = user
    this.customerUserIdCheck(month, showAll)
  }

  cancelSubscription = async (data, handleRemoveDisableCondition) => {
    const { id = '' } = data
    const month = this.props.location?.queryParams?.month || ''
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscription(
      {
        subscriptionId: id,
        patchProperties: {
          status: 'CANCELED',
        },
      },
      { userId: customerContainer.userId, month: month }
    )
    const isPvAssistantEnable =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistEnabled ||
      false
    const pvAssistGoal =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistGoal || '0'
    const orders = subscriptionContainer.subscriptionPreferenceResponse?.order
    const minMonthlyPV = orders?.monthlyPV || '0'

    const itemPV = data?.properties?.pointValue || ''
    const pvDifference = minMonthlyPV - itemPV
    if (subscriptionContainer.isSuccessResponse(response)) {
      isPvAssistantEnable &&
        pvDifference !== 0 &&
        pvDifference < pvAssistGoal &&
        this.renderPvModal()
      await this.getSubscriptionResponse()
      if (customerContainer.isRegisterUser)
        await cartContainer.getSubscriptionCount()
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    handleRemoveDisableCondition && handleRemoveDisableCondition()
  }

  cancelSubscriptionAll = async userid => {
    this.isCancelSubsCallInProgress = true
    const month = this.props.location?.queryParams?.month || ''
    const response = await subscriptionContainer.cancelAllSubscription(
      {
        userId: userid,
        patchProperties: {
          status: 'CANCELED',
        },
      },
      { userId: customerContainer.userId, month: month }
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      if (customerContainer.isRegisterUser)
        await cartContainer.getSubscriptionCount()
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
    } else {
      await this.getSubscriptionResponse()
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    this.isCancelSubsCallInProgress = false
  }

  handleQuantityChange = async (data, count) => {
    const { id, itemInfo } = data
    const { /* quantity, */ ...remainingProps } = itemInfo[0]
    // Removing description related things to avoid waf content length exceeds issue as per architect(s) request
    const { properties, ...productRemainingProps } = remainingProps
    const {
      /* Description,
      'How To Use': howtousewithspace,
      Ingredients,
      'Meta Description': metaDescriptionwithspace,
      'Short Description': shortDescriptiomwithspace,
      'Micro Description': microdesc,
      description,
      ingredients,
      howtouse,
      metadescription,
      shortdescription, */
      ...remainingProperties
    } = properties
    const month = this.props.location?.queryParams?.month || ''
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscription(
      {
        subscriptionId: id,
        patchProperties: {
          itemInfo: [
            {
              ...productRemainingProps,
              properties: remainingProperties,
              quantity: count,
            },
          ],
        },
      },
      { userId: customerContainer.userId, month: month }
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      overlayState.toggleLoader()
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
      return true
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      overlayState.toggleLoader()
      toastState.setToastMessage(errorMessage, false)
      return false
    }
  }

  // Frequency change also handles quantiy update for otp to sub conversion
  handleFrequencyChange = async (
    product,
    value,
    count,
    isOnetime = false,
    convertToSub = false
  ) => {
    const { id = '' } = product
    const frequencyValue = value.split('-')
    const month = this.props.location?.queryParams?.month || ''
    overlayState.toggleLoader()
    let orderType =
      isOnetime === true ? 'VARIABLE_SINGLE_ORDER' : 'VARIABLE_MULTI_ORDER'
    const response = await subscriptionContainer.updateSubscription(
      {
        subscriptionId: id,
        patchProperties: {
          id: id,
          frequencyType: frequencyValue[1],
          frequencyPeriod: parseInt(frequencyValue[0]),
          type: orderType,
          ...(count && {
            itemInfo: [
              {
                quantity: count,
              },
            ],
          }),
        },
      },
      { userId: customerContainer.userId, month: month }
    )
    if (customerContainer.isRegisterUser)
      await cartContainer.getSubscriptionCount()
    await this.getSubscriptionResponse()
    overlayState.toggleLoader()
    if (subscriptionContainer.isSuccessResponse(response)) {
      // Successful monthly sub to One-time sub message
      if (isOnetime) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItemOneTime',
            'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
          ),
          true
        )
      } else if (convertToSub) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.movedToSubscription',
            'Item successfully added to subscription.'
          ),
          true
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.updateSuccess',
            'Your subscription has been updated.'
          ),
          true
        )
      }
      return true
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
      return false
    }
  }

  handleProcessingDate = async count => {
    this.isDateChangeCallInProgress = true
    // const month = this.props.location?.queryParams?.month || ''
    const { payment } = subscriptionContainer.subscriptionPreferenceResponse
    const getPaymentId = payment?.id || ''
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      {
        orderProcessingDate: count,
        paymentId: getPaymentId,
      }
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const pastDateErrorCode =
        errorCode === 'validation.preference.orderprocessingdate.invalid'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.dayNotAvailable',
            'This subscription processing date is full, please select a new date.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : pastDateErrorCode
            ? i18nTranslate(
                'subscription.newPastDateErrorMessage',
                'Order Processing date cannot be on or before current date. Please choose a future date.'
              )
            : (response && response.message) ||
              i18nTranslate(
                'subscription.failure',
                'Sorry, we are unable to update your subscription. Please try again.'
              )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    this.isDateChangeCallInProgress = false
  }

  // renderDateDropDown = (selected, lastOrder) => {
  renderDateDropDown = shouldDisableDateDropdown => {
    const date = []
    const getDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.orderProcessingDate || 0

    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    /* const currentDate =
        subscriptionContainer.subscriptionPreferenceResponse?.
        currentDate ||
        ''
       */
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    // EC-8402 - currentDate format is not supported by Safari 13.1.
    // And so, using the new node 'currentDateInMillis',
    // 'currentDateInMillis' is in timestamp format
    // const dateNow = new Date(parseUTCDate(currentDate || ''))
    // const dateNow = new Date(currentDateInMillis)
    // const currentMonth = dateNow.getMonth() + 1
    // const currentDateNumber = dateNow.getDate()
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const currentDateNumber = new Date(currentDateInMillis).toLocaleDateString(
      [],
      {
        timeZone,
        day: '2-digit',
      }
    )
    let startDay =
      selectedMonth == currentMonth ? parseInt(currentDateNumber) + 1 : 2
    // ^ Release fix:
    // if currentmonth not processed, dropdown should be shown currentDate+1 to 28
    // ---
    // if startday > 28, empty dropdown will be rendered
    // but if startday > 28, order will be processed already as per business logic
    // so dropdown will be disabled, > 28 scenario will not be met anytime
    //let disableDays = [2, 10, 15, 20, 24, 25, 26, 27, 28]
    for (let count = startDay; count <= 28; count++) {
      const isSelectedClass = getDate === count ? 'selected' : ''
      date.push(
        <Dropdown.Item
          className={isSelectedClass}
          disabled={this.isDateChangeCallInProgress}
          as="button"
          data-testid="qa-user-sub-change-processing-day-options"
          value={count}
          onClick={() => {
            this.handleProcessingDate(count)
          }}>
          {count}
        </Dropdown.Item>
      )
    }
    return (
      <Dropdown className="date-dropdown border date-dropdown-width">
        <Dropdown.Toggle
          variant=""
          // id="dropdown-basic"
          className={`date-dropdown-toggle d-flex align-items-center justify-content-between w-100 ${
            shouldDisableDateDropdown ? 'disabled' : ''
          }`}
          data-testid="qa-user-sub-change-processing-day">
          <span className="text-uppercase">
            {i18nTranslate(
              'mysubscriptions.changeProcessDate',
              'Change Process date'
            )}
          </span>
          <span className="date-dropdown-arrow ml-2">
            <Icons
              name="arrows"
              icontype="downarrow"
              ariaLabel={i18nTranslate(
                'subscriptionDate.toggle',
                'Toggle date box'
              )}
              alt={i18nTranslate('subscriptionDate.toggle', 'Toggle date box')}
            />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="date-dropdownmenu">{date}</Dropdown.Menu>
      </Dropdown>
    )
  }
  handleProcessingNow = async (
    isStoreCreditApplied,
    appliedStoreCreditPoints,
    reprocessNow = false
  ) => {
    this.processNowClicked = true
    /* const selectedMonth = 
      subscriptionContainer.subscriptionPreferenceResponse?.
      selectedSubscriptions?.[0]?.selectedMonth ||
      0
     */
    overlayState.toggleLoader()
    const response = isStoreCreditApplied
      ? await subscriptionContainer.updateProcessingNowSubscriptions(
          customerContainer.userId,
          {
            isApplyStoreCredit: true,
            runWithPVAssist: false,
            storeCreditValue: appliedStoreCreditPoints,
            reprocessNow: reprocessNow,
          }
        )
      : reprocessNow
        ? await subscriptionContainer.updateProcessingNowSubscriptions(
            customerContainer.userId,
            {
              isApplyStoreCredit: false,
              runWithPVAssist: false,
              reprocessNow: true,
            }
          )
        : await subscriptionContainer.updateProcessingNowSubscriptions(
            customerContainer.userId,
            {
              isApplyStoreCredit: false,
              runWithPVAssist: true,
              reprocessNow: false,
            }
          )

    await this.getSubscriptionResponse()
    if (subscriptionContainer.isSuccessResponse(response)) {
      // await this.getSubscriptionResponse()

      /* CX121-4495 - same old i18n key,but new value  - Google Translated*/
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.orderCreated',
          'Your order has been placed. You will receive an email confirmation shortly.'
        ),
        true
      )
      this.isToShowProcessNowModal = false
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const processNowResponse = response?.errors?.[0]?.message || ''
      let errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : processNowResponse === 'REQUIRED_NOTNULL'
          ? i18nTranslate(
              'order.submitPhoneError',
              'Missing information for selected address, Please update before moving forward.'
            )
          : response?.message ||
            response?.errorMessage ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    this.processNowClicked = false
  }
  toggleProcessingNowModal = () => {
    this.isToShowProcessNowModal = !this.isToShowProcessNowModal
  }

  isProcessNowErrorForOTP = () => {
    let areAllOtpInPrimarySubscription = true
    let toDisableSubmitOrder = false
    let isActiveLegacySubsExists = false
    const subscriptionValidLength =
      subscriptionContainer?.selectedSubscription?.length > 0 ? true : false
    subscriptionValidLength &&
      subscriptionContainer?.selectedSubscription?.forEach(obj => {
        let skus = (obj?.itemInfo?.length && obj?.itemInfo?.[0]?.skus) || []
        let stockInventory = (
          obj?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
        ).toLowerCase()
        let stockStatus = (
          obj?.itemInfo?.[0]?.skus?.[0]?.status || ''
        ).toLowerCase()

        if (skus.length > 1) {
          const bundleObj = skus.find(
            obj => obj.type === 'BUNDLE' || obj.type === 'SKUKIT'
          )

          stockInventory = bundleObj?.inventory?.toLowerCase()
          stockStatus = bundleObj?.status?.toLowerCase()
        }

        /* Condition is checked here for any subscription items or not skipped items or eligible subscription items are there
         * to not display the one-time error on top process now error msg and process now modal error msg
         * this Condition includes product availablity check also because when there is no instock product means,
         * that time also one-time item will not get processed */
        let isSubsItemsAreInstockAndActive =
          stockInventory !== 'out of stock' && stockStatus !== 'inactive' //To check whether subscribed items are instock and active

        if (
          obj?.type !== 'VARIABLE_SINGLE_ORDER' &&
          obj?.properties?.isSkipped !== 'true' &&
          isSubsItemsAreInstockAndActive &&
          !obj.enableItemLevelProcessing
        ) {
          areAllOtpInPrimarySubscription = false
        }
        // This is to check legacy subscription items to enable/disable submit order button in process now modal
        if (obj.enableItemLevelProcessing && isSubsItemsAreInstockAndActive) {
          isActiveLegacySubsExists = true
        }
        toDisableSubmitOrder = isActiveLegacySubsExists
          ? false
          : areAllOtpInPrimarySubscription
            ? true
            : false
      })
    /*
     * Adding Condition based on whole array types to avoid error on Unskip
     */
    const objectTypesOnlySingleOrder = subscriptionValidLength
      ? subscriptionContainer?.selectedSubscription?.map(item => {
          return item?.type
        })
      : []
    const objectTypeSkipped = subscriptionValidLength
      ? subscriptionContainer?.selectedSubscription?.map(item => {
          return item?.properties?.isSkipped
        })
      : []
    if (
      !objectTypesOnlySingleOrder?.includes('VARIABLE_SINGLE_ORDER') &&
      !objectTypeSkipped.includes(false)
    ) {
      areAllOtpInPrimarySubscription = false
    } else if (!objectTypesOnlySingleOrder?.includes('VARIABLE_MULTI_ORDER')) {
      areAllOtpInPrimarySubscription = true
    }

    let toShowOTPError =
      (areAllOtpInPrimarySubscription &&
        subscriptionContainer?.selectedSubscription?.length > 0) ||
      false
    const processNowFlagsForOneTime = {
      toShowOTPError: toShowOTPError,
      toDisableSubmitOrder: toDisableSubmitOrder,
    }
    return processNowFlagsForOneTime
  }
  renderDonationCheckbox = isToDisableDonation => {
    return (
      <div className="donationMsg">
        <Row noGutters className="my-3">
          <Form.Check
            name="donationCheckbox"
            className={`d-flex check-box-wrap  ${
              this.isDonationCallInProgress ? 'disable-donation' : ''
            }`}
            type="checkbox"
            checked={this.isDonationChecked}
            disabled={isToDisableDonation || this.isDonationCallInProgress}
            onClick={() => this.handleDonationCheck()}
            id="donationCheckbox_1"
            custom
            key="donationCheckbox_1"
            label={i18nTranslate(
              'checkout.donationcheckbox',
              'I agree to donate $1 to the General Donation program'
            )}
            data-testid="qa-checkout-doantion-check-box"
          />
          <Icons className="ml-1" name={'product-icon'} icontype={'tool-tip'} />
        </Row>
      </div>
    )
  }

  getDateFromTimeStamp = timeStamp => {
    const date = new Date(timeStamp)
    const day = date.getDate()
    this.handleProcessingDate(day)
  }

  handleConfirmForDelete = () => {
    this.showModal = false
    const userId = customerContainer.userId
    this.cancelSubscriptionAll(userId)
  }
  handlePopupCancel = () => {
    this.showModal = !this.showModal
  }

  handlePvPopupCancel = () => {
    this.showPvModal = !this.showPvModal
  }
  handlePvPopupConfirm = () => {
    this.showPvModal = !this.showPvModal
  }
  renderConfirmModal = () => {
    this.showModal = true
  }
  isValidDate = date => {
    return date instanceof Date && !isNaN(date)
  }
  handleInfotxt = () => {
    this.isTooltipEnabled = true
  }
  handleCloseInfo = () => {
    this.isTooltipEnabled = false
  }

  handleInfoTool = () => {
    this.isInfoModalEnabled = true
  }

  scanToggleQuickView = () => {
    this.isInfoModalEnabled = false
  }
  deleteToggleQuickView = () => {
    this.isDeleteModalEnabled = false
  }

  renderDeleteInfoModal = () => {
    return (
      <>
        <Modal
          centered={true}
          show={this.isDeleteModalEnabled}
          className="subscription-dialog"
          dialogClassName="quick-view-dialog"
          onHide={this.deleteToggleQuickView}>
          <Modal.Header className="border-0" closeButton>
            <ModalTitle className="font-weight-bold d-flex m-0">
              <InformationIcon size="1.5rem" className="mr-2" />
              {i18nTranslate('subscription.delete', 'Unable to Delete items')}
            </ModalTitle>
          </Modal.Header>
          <Modal.Body>
            {i18nTranslate(
              'subscription.deleteDetails',
              'At least one subscription item must ship with one time items. To delete subscription items, please remove one-time items from your next shipment.'
            )}
          </Modal.Body>
        </Modal>
      </>
    )
  }
  renderScanInfoModal = () => {
    return (
      <>
        <Modal
          centered={true}
          show={this.isInfoModalEnabled}
          dialogClassName="quick-view-dialog"
          onHide={this.scanToggleQuickView}>
          <Modal.Header className="border-0" closeButton>
            <ModalTitle className="font-weight-bold">
              <InformationIconOutline size="1.5rem" className="mr-2" />
              {i18nTranslate('scan.cards', 'SCAN CARDS')}
            </ModalTitle>
          </Modal.Header>
          <Modal.Body>
            <h5>{i18nTranslate('scan.takeAction', 'Take Action')}</h5>
            <ul>
              <li>
                {i18nTranslate(
                  'scan.info1',
                  `Obtain a Scan Card from a Scanner Operator when you scan for the
                first time.`
                )}
              </li>
              <li>
                {i18nTranslate(
                  'scan.info2',
                  `Activate your Scan Card either by telephone or online in
                Subscription Management`
                )}
              </li>
            </ul>
            <h5>{i18nTranslate('scan.benefits', 'The Benefits')}</h5>
            <ul>
              <li>
                {i18nTranslate(
                  'scan.info3',
                  `The scan card is reusable and once activated it becomes a free
                monthly scan as a LIFETIME benefit - for as long as you continue
                your qualified Pharmanex product Subscription.`
                )}
              </li>
              <li>
                {i18nTranslate(
                  'scan.info4',
                  `There are two parts to the card - a large card (similar in size
                to a credit card) and a small card that you can attach to your
                key ring.Both of those will have the same bar coded certificate
                number(your scan card number) and you may use either for your
                personal monthly scan.`
                )}
              </li>
              <li>
                {i18nTranslate(
                  'scan.info5',
                  `Each time you scan with your Scan Card your individual SCS
                results from the BioPhotonic Scanner will be recorded so you may
                track your personal progress each month.`
                )}
              </li>
            </ul>
          </Modal.Body>
        </Modal>
      </>
    )
  }

  renderScanCardInfo = () => {
    const subscriptionProducts = subscriptionContainer.selectedSubscription
    const scanQualifiedSubscriptionProducts =
      subscriptionProducts &&
      subscriptionProducts?.length > 0 &&
      subscriptionProducts?.filter(item => {
        const isMigratedSubscriptionProduct =
          item?.enableItemLevelProcessing || false
        const isOnetimeOrder = item?.type === 'VARIABLE_SINGLE_ORDER' || false
        const bundleItems = subscriptionContainer.getBundleData(item)
        const isBundle = bundleItems?.isBundle || false
        let scanQualifiedCount = 0
        if (isBundle) {
          scanQualifiedCount = Number(
            bundleItems?.mandatoryCount?.some(mandatoryItem => {
              return (
                parseInt(mandatoryItem?.skuProperties?.scanQualifiedCount) > 0
              )
            })
          )
          if (!scanQualifiedCount) {
            scanQualifiedCount = Number(
              bundleItems?.optionalCount?.some(optionalItem => {
                return (
                  parseInt(optionalItem?.skuProperties?.scanQualifiedCount) > 0
                )
              })
            )
          }
        } else {
          scanQualifiedCount =
            item?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.scanQualifiedCount ||
            0
        }
        const scanCardEligibleProduct =
          parseInt(scanQualifiedCount) > 0 &&
          !isMigratedSubscriptionProduct &&
          !isOnetimeOrder

        return scanCardEligibleProduct
      })

    return (
      scanQualifiedSubscriptionProducts &&
      scanQualifiedSubscriptionProducts?.length > 0 && (
        <div className="subscription-scan-card-info">
          <div className="paragraph-m-bold scan-card-title">
            {i18nTranslate('cart.scanCard', 'Scan Card')}
            <button
              aria-label="scancard"
              tabIndex={0}
              id="scan-info-bttn"
              onClick={this.handleInfoTool}
              onMouseOver={() =>
                application.isDesktopOrLarger && (this.isTooltipEnabled = true)
              }
              onMouseOut={() =>
                application.isDesktopOrLarger && (this.isTooltipEnabled = false)
              }>
              <InformationIconOutline size="1.5rem" />
              {this.isTooltipEnabled && (
                <button
                  id="tooltippScantext"
                  autoFocus
                  onBlur={this.handleCloseInfo}>
                  {i18nTranslate(
                    'tooltipScanCard',
                    `Click here to get information about scan card`
                  )}
                </button>
              )}
            </button>
          </div>
        </div>
      )
    )
  }

  renderSubscriptionSavingsView = () => {
    //let usedLanguage = ''

    /* const liveCounts = 
      subscriptionContainer.subscriptionPreferenceResponse?.liveCounts
     */
    const getDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.orderProcessingDate || 0
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || 0
    // const hideProcessingNow = false
    // const hideProcessingNow = selectedMonth !== currentServerDate.getMonth() + 1
    // for now process now button should be visible but disabled
    // const getFullYear = currentServerDate.getFullYear()

    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    const {
      /* freezeOrderDate,
      orderProcessingDate, */
      lastOrderProcessingDate = 0,
      // currentDate = '',
      currentDateInMillis = '',
      startMonth,
      //hasSubscriptionPaymentMethods,
      //lastOrderStatus = '',
      nextOrderProcessingMonth = 0,
      properties = {},
    } = subscriptionContainer.subscriptionPreferenceResponse

    // noSubsInCurrentMonth - true if no subs in current month but subs in future months
    // const noSubsInCurrentMonth =
    //   subscriptionContainer.selectedSubscription?.length <= 0 &&
    //   nextOrderProcessingMonth &&
    //   nextOrderProcessingMonth !== selectedMonth

    // let lastOrderProcessingMonth = new Date(lastOrderProcessingDate).getMonth()
    let lastOrderProcessingMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    let dates = new Date(currentDateInMillis)
    // let currentMonth = dates.getMonth()
    let currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    let currentSelectedMonth =
      lastOrderProcessingMonth == currentMonth ? currentMonth + 1 : currentMonth

    // let year = new Date(currentDateInMillis).toLocaleDateString([], {
    //   timeZone,
    //   year: 'numeric',
    // })
    const year = getConvertedYear(currentDateInMillis, timeZone)

    // let getYear =
    //   currentSelectedMonth > 12 ? date.getFullYear() + 1 : date.getFullYear()
    let getYear = currentSelectedMonth > 12 ? parseInt(year) + 1 : year
    const constructedDate = new Date(year, currentSelectedMonth - 1, getDate)
    // const lastOrderMonth = new Date(lastOrderProcessingDate).getMonth() + 1
    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)
    // const nextOrderProcessingMonth =
    //   new Date(lastOrderProcessingDate).getMonth() + 1
    /*const nextOrderProcessingMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )*/
    /*const nextOrderProcessingDate = new Date(
      getYear,
      nextOrderProcessingMonth,
      getDate
    )
    const lastOrderProcessedDate = new Date(lastOrderProcessingDate)
    // const lastOrderProcessedMonth = new Date(lastOrderProcessingDate).getMonth()
    const orderProcessDate = dateFormatDeps.getDateAsString(
      selectedMonth == lastOrderMonth
        ? lastOrderProcessedDate
        : totalActiveSubscriptionCount == 0
        ? nextOrderProcessingDate
        : Date.parse(constructedDate)
    )*/
    const orderProcessDate = this.isValidDate(constructedDate)
      ? dateFormatDeps.getDateAsStringWithDay(Date.parse(constructedDate))
      : ''
    // const dateNow = new Date(currentDateInMillis)
    // const todaysDate = dateNow.getDate()
    // const currentMonth = dateNow.getMonth()
    //const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    //const isDifferentMonth = selectedMonth != currentMonth
    // current month is returned as 0 for January
    // process now should be enabled only when
    // selectedMonth in dashboard is currentMonth
    // so currentMonth + 1 != selectedMonth -> disable=true
    //const isSelectedMonthAlreadyProcessed = selectedMonth == lastOrderMonth
    // const isFreezeDateReached = todaysDate >= freezeOrderDate
    /* const shouldEnableProcessNow =
      hasSubscriptionPaymentMethods &&
      !isDifferentMonth &&
      !isSelectedMonthAlreadyProcessed */
    //&& !isFreezeDateReached
    // freezedate is not considered in front end for now
    // this is discussed with Selva
    // date should be disabled for current month && if current month processed
    //const shouldDisableDateDropdown = lastOrderMonth == selectedMonth
    // ^this will work only if feed runs everymonth
    // ^if not, won't work for user with frequency like 'every two months'
    // console.log(
    //   'subscription',
    //   isDifferentMonth,
    //   isSelectedMonthAlreadyProcessed,
    //   shouldEnableProcessNow,
    //   selectedMonth,
    //   lastOrderMonth,
    //   shouldEnableDateDropdown
    // )
    const subscriptionProducts = subscriptionContainer.selectedSubscription
    // let emptyTemplate = subscriptionProducts.length > 0 ? false : true

    // This is to show Next processing date and change processing button in the side bar
    // if (noSubsInCurrentMonth) {
    //   emptyTemplate = false
    // }

    /* const enableReprocessNow =
      lastOrderMonth == currentMonth &&
      lastOrderStatus.toLowerCase() == 'order_failed' */

    //const subscriptionProducts = subscriptionContainer.selectedSubscription

    //The below date is used to extract the month
    // let textMonth = new Date(1995, selectedMonth - 1, 17)
    // textMonth = textMonth.toLocaleString('default', { month: 'long' })
    //let textMonth = dateFormatDeps.matchMonthFromNumberToString(selectedMonth)

    const selectedDateCalendar =
      selectedMonth && getDate && getYear
        ? `${selectedMonth}/${getDate}/${getYear}`
        : ''
    let monthPv = this.props.location?.queryParams?.month || ''
    let showDiv = monthPv === 'pvassistant' && getAppConfig().shouldShowPvAssit
    let orderProcessingThreshold = {}
    try {
      orderProcessingThreshold = JSON.parse(
        properties.orderProcessingDateThreshold || {}
      )
    } catch (e) {
      console.log('Parse Error on order processing threshold')
    }

    let calenderExcludedDaysThreshold = []
    for (let blackoutdate in orderProcessingThreshold) {
      orderProcessingThreshold[blackoutdate]?.threshold <= 0 &&
        calenderExcludedDaysThreshold.push(blackoutdate)
    }
    /* to be checked and changed later based on  APPConfig?.getAppConfig()?.defaultProcessingDate */
    /* CX15-9174 */
    const calenderExcludedDays =
      calenderExcludedDaysThreshold.length === 0
        ? [29, 30, 31]
        : calenderExcludedDaysThreshold
    //const calenderExcludedDays = [1, 2, 29, 30, 31]
    const excludeDates = calenderExcludedDays.map(day => {
      return new Date(getYear, selectedMonth - 1, day)
    })
    const minDate = new Date(getYear, selectedMonth - 1, 1)
    const maxDate = new Date(getYear, selectedMonth, 0)

    const today = new Date(
      dates.toLocaleDateString([], {
        // timeZone: timeZone,
        /**
         * @todo
         * timeZone required here - facing firefox error
         */
        timeZone: 'US/Mountain',
      })
    )

    const hasSubscription =
      cartContainer.subscriptionResponse?.isSubscriptionPreference || false

    return (
      <>
        {!showDiv && (
          <div className="d-inline-block w-100">
            {orderProcessDate && (
              <div className="subscription-savings p-0 d-inline-block w-100">
                <p className="m-0 order-processing-title paragraph-m text-center">
                  {selectedMonth == lastOrderMonth
                    ? i18nTranslate(
                        'mysubscriptions.orderAlreadyProcessed',
                        'Your next order will be processed on'
                      )
                    : i18nTranslate(
                        'mysubscriptions.orderProcess',
                        'Your next order will be processed on'
                      )}
                </p>
                <p
                  className="order-processing-date paragraph-m-bold text-center"
                  data-testid="qa-user-sub-order-processing-date">
                  {orderProcessDate}
                </p>
                {!subscriptionContainer.allUsers && (
                  <DatePicker
                    className="myaccount-btn mt-2 mt-md-0 btn btn-primary process-date-button w-100"
                    data-testid="qa-datepicker-input-container"
                    popperClassName="datepicker-z-index"
                    selected={
                      selectedDateCalendar
                        ? new Date(selectedDateCalendar)
                        : new Date()
                    }
                    disabled={this.isDateChangeCallInProgress}
                    onChange={this.getDateFromTimeStamp}
                    minDate={minDate > dates ? minDate : dates}
                    maxDate={maxDate}
                    excludeDates={[...excludeDates, today]}
                    dayClassName={day => {
                      return day < today &&
                        day > minDate &&
                        !excludeDates.find(item => {
                          return item.getTime() == day.getTime()
                        })
                        ? 'draw-slash'
                        : undefined
                    }}
                    customInput={
                      <button>
                        {i18nTranslate(
                          'mysubscriptions.changeProcessDate',
                          'Change Processing Date'
                        )}
                        <Icons
                          name="form-icon"
                          icontype="date-picker"
                          width="18px"
                          className="ml-1"
                        />
                      </button>
                    }
                  />
                )}
              </div>
            )}
          </div>
        )}
      </>
    )
  }
  getPrice = custompriceValue => {
    const formattedPrice = currencyFormat({
      price: custompriceValue,
    })
    const formattedCustomPrice = formattedPrice.replace('$', '')
    return formattedCustomPrice
  }

  @action
  setProcessingMonth = val => {
    this.processingMonth = val
  }

  getTotalPriceValue = (label = '') => {
    let totalValue = 0
    const primaryTransactionOrder =
      subscriptionContainer?.subscriptionPreferenceResponse?.order?.value || {}
    const primaryTransactionValue = primaryTransactionOrder?.[label] || 0
    totalValue = totalValue + primaryTransactionValue
    const migratedTransactionValue =
      subscriptionContainer?.subscriptionPreferenceResponse?.transaction || {}
    const transactionArray = Object.values(migratedTransactionValue) || []
    transactionArray?.forEach(item => {
      let itemValue = item?.value?.[label] || 0
      totalValue = totalValue + itemValue
    })
    return totalValue
  }

  // Function to check if there are any One-time subs and calc total
  getOnetimeTotalPrice = () => {
    let totalValue = 0
    const inventoryErrorStatus = ['out of stock', 'discontinued']
    subscriptionContainer?.selectedSubscription?.forEach(obj => {
      if (
        obj?.type === 'VARIABLE_SINGLE_ORDER' &&
        !inventoryErrorStatus.includes(
          obj?.itemInfo?.[0]?.skus?.[0]?.inventory?.toLowerCase()
        ) &&
        obj?.status === 'ACTIVE'
      ) {
        totalValue += obj?.itemInfo?.[0]?.totalValue?.originalPrice || 0
      }
    })
    return totalValue
  }

  getMonthlyTotalValue = (label = '') => {
    let monthlyTotal = 0
    const primaryTransactionOrder =
      subscriptionContainer?.subscriptionPreferenceResponse?.order || {}
    const primaryTransactionValue = primaryTransactionOrder?.[label] || 0
    monthlyTotal = monthlyTotal + primaryTransactionValue
    const migratedTransactionValue =
      subscriptionContainer?.subscriptionPreferenceResponse?.transaction || {}
    const transactionArray = Object.values(migratedTransactionValue) || []
    transactionArray?.forEach(item => {
      let itemValue = item?.[label] || 0
      monthlyTotal = monthlyTotal + itemValue
    })
    return monthlyTotal
  }

  getMonthlyPVValue = (label = '') => {
    let monthlyPV = 0
    const primaryTransactionOrderPV =
      subscriptionContainer?.subscriptionPreferenceResponse?.order
        ?.totalPriceFacets?.PV || {}
    const primaryTransactionValue = primaryTransactionOrderPV?.[label] || 0
    monthlyPV = monthlyPV + primaryTransactionValue
    const migratedTransactionValue =
      subscriptionContainer?.subscriptionPreferenceResponse?.transaction || {}
    const transactionArray = Object.values(migratedTransactionValue) || []
    transactionArray?.forEach(item => {
      let itemValue = item?.totalPriceFacets?.PV?.[label] || 0
      monthlyPV = monthlyPV + itemValue
    })
    return monthlyPV
  }
  getCartPromotions = () => {
    const itemPromotions = []
    subscriptionContainer?.subscriptionPreferenceResponse?.selectedSubscriptions?.[0]?.subscriptions?.forEach(
      item => {
        if (
          item?.itemInfo?.[0] &&
          item?.itemInfo?.[0]?.promotions &&
          isArray(item?.itemInfo?.[0]?.promotions)
        ) {
          itemPromotions.push(...item?.itemInfo?.[0]?.promotions)
        }
      }
    )
    let promotionDetails =
      subscriptionContainer?.subscriptionPreferenceResponse?.promotionDetails
        ?.promotions || []
    let result = []
    const overallPromotions = [...itemPromotions, ...promotionDetails]
    overallPromotions?.map(promotion => {
      const promoBreakup = promotion?.breakup || []
      const promoBreakupWithDiscount = promoBreakup?.filter(promo => {
        return (
          promo?.isGift ||
          (promo?.totalValue && promo?.identifier.toLowerCase() != 'loyalty')
        )
      })
      result.push(...promoBreakupWithDiscount)
    })
    return result
  }
  freeProducts = () => {
    let skus = []
    let freeGiftProducts = []
    const items = cartContainer?.cartResponse?.items
    items?.map(item => {
      if (item.properties && item.properties.isGiftItem) {
        freeGiftProducts.push(item)
      }
    })
    if (freeGiftProducts.length > 0) {
      for (let i = 0; i < freeGiftProducts.length; i++) {
        skus.push(freeGiftProducts[i].skus[0].skuId)
      }
    }
    return skus
  }
  renderCartPromotions = (promoBreakup = []) => {
    let tempPromoArray = []
    return promoBreakup?.map((promotion, index) => {
      const NotOutOfStock = promotion?.isGift
        ? this.freeProducts()?.includes(promotion?.skuId)
        : true
      const displayMessage = promotion?.displayMessage || ''
      const message = promotion?.message || displayMessage || ''
      if (!tempPromoArray?.includes(promotion?.identifier)) {
        tempPromoArray?.push(promotion?.identifier)
        return (
          <>
            {NotOutOfStock && (
              <div className="cart-promotions" key={index}>
                {message}
              </div>
            )}
          </>
        )
      }
    })
  }
  renderPromotionsToolTip = () => {
    /* to display cartLevelPromotions as tooltip*/
    const cartPromotions = this.getCartPromotions()
    if (cartPromotions?.length) {
      const promotionsView = this.renderCartPromotions(cartPromotions)
      return (
        <>
          <OverlayTrigger
            placement="top-end"
            delay={{ show: 100, hide: 250 }}
            overlay={
              <div className="promotions-tooltip">{promotionsView}</div>
            }>
            <InformationIcon className="cart-promo-info-icon" />
          </OverlayTrigger>
        </>
      )
    }
    return <></>
  }

  @action
  renderSubscriptionRewardsViewSummary = () => {
    const {
      /* freezeOrderDate,
      orderProcessingDate, */
      lastOrderProcessingDate = 0,
      // currentDate = '',
      currentDateInMillis = '',
      //startMonth,
      hasSubscriptionPaymentMethods,
      lastOrderStatus = '',
      payment,
      selectedSubscriptions = {},
    } = subscriptionContainer.subscriptionPreferenceResponse

    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)

    // Hide 'process now' button for 'show all' tab of sub dash
    const hideProcessingNow =
      this.props.location?.queryParams?.month === 'showall'
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const enableReprocessNow =
      lastOrderMonth == currentMonth &&
      lastOrderStatus.toLowerCase() == 'order_failed'
    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const isDifferentMonth = selectedMonth != currentMonth
    const isSelectedMonthAlreadyProcessed = selectedMonth == lastOrderMonth
    let textMonth = dateFormatDeps.matchMonthFromNumberToString(selectedMonth)
    let isAssociatedCardExpired = false
    let isCardExpiredForNormalSubs = checkIfCardIsExpired(
      payment?.cardExpirationMonth,
      payment?.cardExpirationYear
    )
    const migratedSubscriptionPrdts =
      subscriptionContainer.selectedSubscription || []

    let isCardExpiredForLegacySubs = false
    if (Array.isArray(migratedSubscriptionPrdts)) {
      isCardExpiredForLegacySubs = migratedSubscriptionPrdts.some(sub => {
        if (sub?.enableItemLevelProcessing) {
          return checkIfCardIsExpired(
            sub?.paymentInfo?.cardExpirationMonth,
            sub?.paymentInfo?.cardExpirationYear
          )
        } else {
          return false
        }
      })
    }
    isAssociatedCardExpired =
      isCardExpiredForNormalSubs || isCardExpiredForLegacySubs

    const shouldEnableProcessNow =
      hasSubscriptionPaymentMethods &&
      !isDifferentMonth &&
      !isSelectedMonthAlreadyProcessed &&
      !isAssociatedCardExpired

    const isToDisableEdit =
      lastOrderMonth == selectedMonth &&
      lastOrderStatus.toLowerCase() == 'order_created'

    const loyalty =
      subscriptionContainer.subscriptionPreferenceResponse?.loyalty || ''
    const orders =
      subscriptionContainer.subscriptionPreferenceResponse?.order || ''
    const TotalPVCV =
      subscriptionContainer.subscriptionPreferenceResponse?.order
        ?.totalPriceFacets || ''
    const CVPrice = TotalPVCV?.CV?.CV || 0
    const PVPrice = TotalPVCV?.PV?.PV || 0
    const CVPriceDis = TotalPVCV?.CV?.CVAfterDiscount || 0
    const PVPriceDis = this.getMonthlyPVValue('PVAfterDiscount') || 0
    const CVPriceOriginal = this.getPrice(CVPrice)
    const PVPriceOriginal = this.getPrice(PVPrice)
    const CVPriceDiscount = this.getPrice(CVPriceDis)
    const PVPriceDiscount = this.getPrice(PVPriceDis)

    const monthlyTotal = orders?.monthlyTotal || ''

    const monthlyOrderTotal = monthlyTotal
      ? parseFloat(monthlyTotal).toFixed(2)
      : 0
    //const monthlyPV = orders?.monthlyPV || '0'
    const minMonthlyPV = orders?.monthlyPV || '0'
    /* const myTotalPts = parseFloat(
      loyalty?.totalPoints || '0'
    ).toFixed(2) */
    /* const myPointsExpiration = parseFloat(
      loyalty?.nextExpirationPoints || '0'
    ).toFixed(2) */

    let itemPrice = this.getTotalPriceValue('originalPrice')

    // One-time subscription total is calculated in JS,
    // and subtracted from sub original total price
    let oneTimeSubTotal = this.getOnetimeTotalPrice()
    if (oneTimeSubTotal > 0) {
      itemPrice -= oneTimeSubTotal
    }

    const shippingAndHandeling = this.getTotalPriceValue('cartDeliveryCharge')

    const subscribeAndSave = this.getTotalPriceValue('overAllDiscount')

    const overAllTax = this.getTotalPriceValue('overAllTax')

    const monthlyPrice = this.getMonthlyTotalValue('monthlyTotal')

    const pointsEarned = parseFloat(
      loyalty?.pointEarnedThisOrder || '0'
    ).toFixed(2)
    const loyaltyPt = loyaltyContainer.getOpenLoyaltyPoints()
    //const earningRate = loyalty?.earningRatePercentage || '0'
    /* const consecutiveMonths =
      loyalty?.continuousSubscriptionMonth || '0'
    const tooltipPosition = application.isMobile ? 'top-start' : 'top-end'
    const successIconTitle = i18nTranslate('icons.toolTipSuccess', 'Success Icon')
    const failureIconTitle = i18nTranslate('icons.toolTipFailure', 'Failure Icon') */

    const itemLabel =
      i18nTranslate('checkout.subscriptionTitle', 'Subscription') +
      ' ' +
      i18nTranslate('items', 'Items')
    const oneTimeSubLabel =
      i18nTranslate('subscription.oneTime', 'One-time') +
      ' ' +
      i18nTranslate('items', 'Items')
    const taxLabel = i18nTranslate('tax', 'Tax')
    const discountLabel = i18nTranslate('discount', 'Discount')
    const shippingLabel = i18nTranslate('shipping', 'Shipping')
    const orderTotal = i18nTranslate('orderTotal', 'Order Total')
    const priceLabel = i18nTranslate('price', 'Price ', {
      nameSpace: 'ssr-resource',
    })
    const totalPvLabel = i18nTranslate('price.TotalSV', 'Total SV', {
      nameSpace: 'ssr-resource',
    })

    // dollar is harcoded
    const itemsPrice = currencyFormat({
      price: itemPrice || 0,
    })

    const oneTimeSubsPrice = currencyFormat({
      price: oneTimeSubTotal || 0,
    })

    const overAllTaxPrice = currencyFormat({
      price: overAllTax || 0,
    })

    const subscribeAndSavePrice = currencyFormat({
      price: subscribeAndSave || 0,
    })

    const shippingAndHandelingPrice = currencyFormat({
      price: shippingAndHandeling || 0,
    })

    const orderTotalPrice = currencyFormat({
      price: monthlyPrice || 0,
    })
    this.viewallTotal = orderTotalPrice
    let accounts = customerContainer.profileResponse?.accounts || {}
    let accountType = accounts?.type || ''
    let isToShowTotalPV =
      accountType?.includes('Brand Affiliate') ||
      accountType?.includes('Preferred Customer/Member') ||
      false

    return (
      <div className="TransactionDetailsHeadier">
        <div
          className={`text-uppercase shipping-text heading-6 shipping-title ${
            this.props.location?.queryParams?.month === 'showall'
              ? 'd-none'
              : 'd-flex align-items-center'
          }`}>
          {/* {i18nTranslate('transactionDetails', 'Transaction Details')} */}
          {i18nTranslate(
            'subscription.totalTransactionDetails',
            'Total Transaction Details'
          )}
          <OverlayTrigger
            trigger="click"
            placement="top"
            rootClose
            overlay={
              <Tooltip id="transaction-details-tooltip">
                {`${i18nTranslate(
                  'subscription.transactionDetailsInfo',
                  'Total Transaction Details includes primary subscription and migrated subscription totals, as applicable.'
                )}${
                  oneTimeSubTotal > 0 && this.isToEnableOneTimeFrequency
                    ? i18nTranslate(
                        'subscription.transactionDetailsOneTimeInfo',
                        ' Any one-time items on promotion will have pricing applied at time of processing, if available.'
                      )
                    : ''
                }`}
              </Tooltip>
            }>
            <InformationIcon
              aria-label="Information tooltip"
              tabIndex={0}
              size="1.5rem"
              id="info-black-button-transaction-details"
              className="infotool ml-1"
            />
          </OverlayTrigger>
        </div>
        <Row
          noGutters
          className={`flex-row row justify-content-between transaction-content ${
            this.props.location?.queryParams?.month === 'showall'
              ? 'd-none'
              : 'd-flex'
          }`}>
          <div className="price_list paragraph-m">
            {itemPrice > 0 && <div>{itemLabel}:</div>}
            {/* Show one time total label only if there are one time sub products */}
            {oneTimeSubTotal > 0 && this.isToEnableOneTimeFrequency && (
              <div>{oneTimeSubLabel}:</div>
            )}
            <div>{taxLabel}:</div>
            <div>{shippingLabel}:</div>
            <div>
              {discountLabel}{' '}
              {subscribeAndSave > 0 && this.renderPromotionsToolTip()}:
            </div>
            <div>{orderTotal}:</div>
            {isToShowTotalPV && (
              <div className="total-subs-pv">{totalPvLabel}:</div>
            )}
          </div>
          <div className="price_number paragraph-m">
            {itemPrice > 0 && (
              <div aria-label={itemLabel + ' ' + priceLabel + ' ' + itemsPrice}>
                {itemsPrice}
              </div>
            )}
            {/* Show one time total label only if there are one time sub products */}
            {oneTimeSubTotal > 0 && this.isToEnableOneTimeFrequency && (
              <div
                aria-label={
                  oneTimeSubLabel + ' ' + priceLabel + ' ' + oneTimeSubsPrice
                }>
                {oneTimeSubsPrice}
              </div>
            )}
            <div
              aria-label={taxLabel + ' ' + priceLabel + ' ' + overAllTaxPrice}>
              {overAllTaxPrice}
            </div>
            <div
              aria-label={
                shippingLabel +
                ' ' +
                priceLabel +
                ' ' +
                shippingAndHandelingPrice
              }>
              {shippingAndHandelingPrice}
            </div>
            <div
              aria-label={
                discountLabel + ' ' + priceLabel + ' ' + subscribeAndSavePrice
              }>
              {`${subscribeAndSave > 0 ? '-' : ''}${subscribeAndSavePrice}`}
            </div>
            <div
              aria-label={
                orderTotal + ' ' + priceLabel + ' ' + orderTotalPrice
              }>
              {orderTotalPrice}
            </div>
            {isToShowTotalPV && (
              <div
                className="total-subs-pv"
                aria-label={
                  totalPvLabel + ' ' + priceLabel + ' ' + PVPriceDiscount
                }>
                {PVPriceDiscount}
              </div>
            )}
          </div>
        </Row>

        <div className={hideProcessingNow ? '' : 'mt-4'}>
          {!subscriptionContainer.allUsers &&
            (hideProcessingNow ? (
              ''
            ) : !enableReprocessNow ? (
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ display: shouldEnableProcessNow ? 'none' : '' }}
                    id="disabled-process-now-tooltip">
                    {isAssociatedCardExpired
                      ? i18nTranslate(
                          'payment.cardExpiredText',
                          'Card is Expired'
                        )
                      : `${i18nTranslate(
                          'subscription.ProcessNowTooltip',
                          'Available to process on'
                        )} ${textMonth} 1`}
                  </Tooltip>
                }>
                <span className="d-flex flex-row process-now">
                  <Button
                    style={{
                      pointerEvents: shouldEnableProcessNow ? '' : 'none',
                    }}
                    variant="transparent"
                    aria-disabled={shouldEnableProcessNow ? 'false' : 'true'}
                    aria-describedby={`${
                      !shouldEnableProcessNow && 'disabled-process-now-tooltip'
                    }`}
                    className={`${
                      !shouldEnableProcessNow ? 'btn-disabled' : ''
                    } myaccount-btn mt-2 mt-md-0 mb-0 ml-0 mr-0 w-100 btn btn-primary  process-now-button`}
                    // disabled={!shouldEnableProcessNow}
                    onClick={this.toggleProcessingNowModal}>
                    {isSelectedMonthAlreadyProcessed
                      ? i18nTranslate(
                          'mysubscriptions.orderProcessed',
                          'Order has processed'
                        )
                      : i18nTranslate(
                          'mysubscriptions.processNow',
                          'Process Now!'
                        )}
                  </Button>
                </span>
              </OverlayTrigger>
            ) : (
              <Button
                variant="transparent"
                className="process-action w-100 rounmonth-listed-0 text-uppercase secondary-button"
                disabled={this.processNowClicked}
                onClick={() => {
                  this.toggleProcessingNowModal()
                }}>
                {i18nTranslate(
                  'mysubscriptions.reProcessNow',
                  'Re-Process Now'
                )}
                !
              </Button>
            ))}
        </div>
      </div>
    )
  }
  /* renderSubscriptionRewardsView = () => {
    const loyalty = 
      subscriptionContainer.subscriptionPreferenceResponse?.loyalty
    )
    const orders = 
      subscriptionContainer.subscriptionPreferenceResponse?.order
    )

    const monthlyOrderTotal = parseFloat(
      orders?.monthlyTotal || '0'
    ).toFixed(2)
    const monthlyPV = orders?.monthlyPV || '0'
    const minMonthlyPV = orders?.monthlyPV || '0'
    const myTotalPts = parseFloat(
      loyalty?.totalPoints || '0'
    ).toFixed(2)
    const myPointsExpiration = parseFloat(
      loyalty?.nextExpirationPoints || '0'
    ).toFixed(2)
    const pointsEarned = parseFloat(
      loyalty?.pointEarnedThisOrder || '0'
    ).toFixed(2)
    const earningRate = loyalty?.earningRatePercentage || '0'
    const consecutiveMonths =
      loyalty?.continuousSubscriptionMonth || '0'
    const tooltipPosition = application.isMobile ? 'top-start' : 'top-end'
    const successIconTitle = i18nTranslate('icons.toolTipSuccess', 'Success Icon')
    const failureIconTitle = i18nTranslate('icons.toolTipFailure', 'Failure Icon')
    return (
      <div className="subscription-summary p-3 mt-4">
        <div className="subscription-summary-item d-flex justify-content-between pb-4">
          <span>
            {i18nTranslate("mysubscriptions.monthlyTotal", 
              "Monthly Order Total")} 
          </span>
          <span data-testid="qa-user-sub-monthly-order-total">
            {`$${monthlyOrderTotal}`} USD
          </span>
        </div>
        <div className="subscription-summary-item d-flex justify-content-between">
          <span>
            {i18nTranslate("mysubscriptions.monthlyPV", "Monthly PV")}
          </span>
          <span data-testid="qa-user-sub-monthly-pv-value">{monthlyPV}</span>
        </div>
        <div className="loyalty-rewards-wrap mt-3 py-3">
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span className="font-weight-bold">
              {i18nTranslate("mysubscriptions.loyaltyReward", 
                "Loyalty Points")}
            </span>
            <span>
              <LinkWithLocale
                className={'text-decoration-none loyalty-learnMore'}
                data-testid="qa-user-sub-loyalty-learn-more"
                aria-label={`${i18nTranslate(
                  'mysubscriptions.learnmore',
                  'Learn more'
                )} button`}
                to="/company/essential-rewards">
                {i18nTranslate("mysubscriptions.learnmore", "Learn more")}
              </LinkWithLocale>
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span>
              {i18nTranslate("mysubscriptions.minMonthlyPV",
                "Min Monthly PV")}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.minMonthlyPVToolTip",
                      `To qualify for reward points and loyalty gifts, you must
                      have at least 50 PV (point value of products) process on
                      subscription each month.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.minMonthlyPV',
                        'Min Monthly PV Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="d-flex"
              data-testid="qa-user-sub-min-monthy-pv-value">
              {minMonthlyPV}/50
              {minMonthlyPV >= 50 ? (
                <span className="success-tick">
                  <Icons
                    name="CRUD"
                    icontype="tick"
                    width="15px"
                    height="15px"
                    color="#8C6E43"
                  />
                </span>
              ) : (
                <span className="failure-tick">
                  <Icons
                    name="CRUD"
                    width="15px"
                    height="15px"
                    icontype="cross"
                    color="#ff0000"
                  />
                </span>
              )}
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span>
              {i18nTranslate("mysubscriptions.myTotalPts",
                "My Total Points")}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.myTotalPtsToolTip",
                      `This is the number of reward points you have accumulated
                      thus far from consecutive monthly subscription orders.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.totalPoints',
                        'Total Points Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="font-weight-bold"
              data-testid="qa-user-sub-my-total-points-value">
              {myTotalPts}
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span>
              {i18nTranslate("mysubscriptions.myPtsExpiring",
                "My Points Expiring Soon")}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.myPtsExpiringToolTip",
                      `This is the number of reward points that will expire this
                      month. Points expire 12 months from the date they were
                      earned.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.pointsExpireSoon',
                        'Points Expire Soon Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="font-weight-bold"
              data-testid="qa-user-sub-my-points-expiring-soon">
              {myPointsExpiration}
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span>
              {i18nTranslate("mysubscriptions.pointsEarned",
                "Points Earned This Order")}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.pointsEarnedToolTip",
                     `This is the number of reward points you will earn once you
                      place this order.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.pointsEarned',
                        'Points Earned Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="font-weight-bold"
              data-testid="qa-user-sub-points-earned-from-this-order">
              {pointsEarned}
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between pb-4">
            <span>
              {i18nTranslate("mysubscriptions.earningRates", 'My earning rate')}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.earningRatesToolTip",
                      `This percentage is calculated by the number of consecutive
                      months you have placed subscription orders of at least
                      50PV.`)}
                      <br />
                      {i18nTranslate("mysubscriptions.onetothreemonth",
                      `• 1-3 months: 10 percent of your PV order back in reward
                      points`)}
                       <br />
                       {i18nTranslate("mysubscriptions.fourtotwentyfourmonth",
                       `• 4-24 months: 20 percent of your PV order
                      back in reward points <br />• 25+ months: 25 percent of
                      your PV order back in reward points.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.earningRate',
                        'Earning Rate Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="font-weight-bold"
              data-testid="qa-user-sub-my-earn-rate">
              {earningRate}%
            </span>
          </div>
          <div className="subscription-summary-item d-flex justify-content-between">
            <span>
              {i18n.t)("mysubscriptions.ConsecutiveMonths", 
                "Consecutive Months")}
              <OverlayTrigger
                placement={tooltipPosition}
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <div className="tooltip-message">
                    {i18nTranslate("mysubscriptions.ConsecutiveMonthsToolTip",
                      `This is the number of months you have consecutively placed
                      a subscription order of at least 50PV.`)}
                  </div>
                }>
                <span className="text-white rewards-tooltip-icon ml-1">
                  <sup>
                    <Icons
                      name="product-icon"
                      icontype="tool-tip"
                      width="13px"
                      height="13px"
                      customicon={i18nTranslate(
                        'toolTipIcons.consecutiveMonth',
                        'Consecutive Month Tool Tip'
                      )}
                    />
                  </sup>
                </span>
              </OverlayTrigger>
            </span>
            <span
              className="font-weight-bold"
              data-testid="qa-user-sub-consecutive-months">
              {consecutiveMonths}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <LinkWithLocale
            to={pageNames.myaccountrewardpoint}
            className={
              'text-uppercase text-decoration-none loyalty-rewards-action'
            }
            data-testid="qa-user-sub-loyalty-rewards-history-link">
            {i18nTranslate("mysubscriptions.loyaltyRewardsHistory", 
              "View Loyalty points history")}
          </LinkWithLocale>
        </div>
      </div>
    )
  }*/

  renderSummaryTemplateEmpty = () => {
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || 0
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || ''
    const orderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.orderProcessingDate || ''
    const subscriptionProducts =
      subscriptionContainer.selectedSubscription || []

    if (
      totalActiveSubscriptionCount != 0 &&
      lastOrderProcessingDate &&
      orderProcessingDate &&
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions &&
      this.userList?.length
    ) {
      return (
        <div
          className={
            subscriptionProducts && subscriptionProducts.length > 0
              ? 'subscription-product-view d-flex'
              : ''
          }>
          <div
            className={`${subscriptionContainer.allUsers} ? '' : left-section`}>
            {this.renderNoSubscriptionsFound()}
          </div>
          {/* {subscriptionContainer.allUsers &&
            subscriptionProducts &&
            subscriptionProducts.length > 0 && (
              <div className="right-section ml-3">
                {this.renderSubscriptionSavingsView()}
              </div>
            )} */}
        </div>
      )
    } else {
      return this.renderNoSubscriptionsFound()
    }
  }

  renderLostBenefitsBlock = () => {
    const loyaltyPoints =
      this.loyaltyPoints?.userMath?.LOYALTY?.total?.openToRedeem || 0
    const orderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.orderProcessingDate || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0

    let date = new Date(lastOrderProcessingDate)
    const nextExpirationMonth = date.getMonth() + 1
    // this is a random date used to get month as string
    let month = new Date(1995, nextExpirationMonth, 17)
    const benefitsExpireMonth = month.toLocaleString('default', {
      month: 'long',
    })

    const discountStartDate =
      customerContainer.profileResponse?.customProperties
        ?.csrDiscountEnabledDaysCount || 0
    let subsExpireDate = new Date(0)
    subsExpireDate.setUTCMilliseconds(discountStartDate)
    subsExpireDate.setDate(subsExpireDate.getDate() + 366)
    const finalDate = subsExpireDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
    const discountWhole =
      discountStartDate != 0
        ? finalDate
        : `${benefitsExpireMonth} ${orderProcessingDate}`

    return (
      <div className="no-subscription-found">
        <div className="benefit-no-subscription text-center">
          {i18nTranslate('mysubscriptions.noFound', 'No Subscription Found')}
        </div>
        <div className="benefit-description text-center">
          {i18nTranslate(
            'mysubscriptions.noFoundtext',
            `To subscribe products, click "Add To subscription" in the product
            page. You can later manage your subscriptions here.`
          )}
        </div>
      </div>
    )
  }

  renderNoSubscriptionsFound = () => {
    const navigationUrl = '/'
    const subscriptionProducts = subscriptionContainer.selectedSubscription
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || 0
    const hasSubscription =
      cartContainer.subscriptionResponse?.isSubscriptionPreference || false
    if (subscriptionContainer.allUsers && this.userList?.length == 0) {
      return (
        <>
          <span className="d-flex justify-content-center pt-4">
            {i18nTranslate(
              'mysubscriptions.noSubscriptionFound',
              'No users found'
            )}
          </span>
        </>
      )
    }
    return hasSubscription && totalActiveSubscriptionCount == 0 ? (
      this.renderLostBenefitsBlock()
    ) : (
      <>
        <span className="d-flex justify-content-center pt-4">
          {i18nTranslate(
            'mysubscriptions.noSubscriptionFound',
            'No Subscriptions Found'
          )}
        </span>
        {(totalActiveSubscriptionCount == 0 ||
          subscriptionProducts?.length == 0) && (
          <div className="start-subscription-wrapper d-flex w-100 justify-content-center text-uppercase mt-3 mb-3 text-center">
            <LinkWithLocale to={navigationUrl}>
              {i18nTranslate(
                'mysubscriptions.startShoppingToday',
                'Start Shopping Today'
              )}
            </LinkWithLocale>
          </div>
        )}
      </>
    )
  }
  renderPaymentFailedError = () => {
    let errorMessage = (
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderStatusMessage || ''
    )?.toLowerCase()
    if (errorMessage === '0') {
      return ''
    }
    errorMessage = errorMessage.replace(/\_/g, '.')
    return (
      <span className="d-flex justify-content-center pb-4 pb-lg-5  text-danger">
        {i18nTranslate(
          `subscription.errorMessage`,
          `Your subscription has not processed due to failed payment. Please
          update your subscription payment method.`
        )}
      </span>
    )
  }

  renderSubscriptionError = () => {
    return (
      <div className="err-subscription mb-2">
        <ServiceErrorUI />
      </div>
    )
  }

  renderSubscriptionOffer = subscriptionOfferLabel => {
    return (
      <div className="d-flex align-items-center justify-content-between offer-subscription mt-2 mb-2 mr-lg-4 mr-md-4">
        <h3 className="pl-2 pt-2" data-testid="qa-user-sub-save-24-message">
          {subscriptionOfferLabel}
        </h3>
        <Button variant="outline-transparent" className="p-0 mr-2">
          <LinkWithLocale to={`/`} data-testid="qa-user-sub-save-24-shop-now">
            {i18nTranslate('mysubscriptions.shopNow', 'Shop Now')}
          </LinkWithLocale>
        </Button>
      </div>
    )
  }

  subscriptionOfferMessage = () => {
    const offerResponse =
      subscriptionContainer.subscriptionPreferenceResponse?.liveCounts || {}
    const subscriptionOfferData = offerResponse?.offerDetails || []
    let subscriptionOfferLabel = ''
    // let subscriptionAriaLabel = ''
    let showSubscriptionOffer
    if (subscriptionOfferData.length) {
      const { /* minOffer, */ maxOffer, quantity } =
        cartContainer.getMinMaxValue(subscriptionOfferData)
      const minProductsToEligible = quantity?.min || '0'
      const productCountNeeded =
        parseInt(minProductsToEligible) -
        parseInt(offerResponse?.totalActiveSubscriptionItemQuantityCount || 0)
      showSubscriptionOffer = productCountNeeded > 0 ? true : false
      const subscriptionStartLabel = i18nTranslate(
        'mysubscriptions.saveFirstLabel',
        'Save'
      )
      const subscriptionMiddleLabel = i18nTranslate(
        'mysubscriptions.saveSecondLabel',
        'on your delivery by subscribing to'
      )
      const subscriptionEndLabel = i18nTranslate(
        'mysubscriptions.saveThirdLabel',
        'more products.'
      )
      subscriptionOfferLabel = `${subscriptionStartLabel} ${maxOffer}% ${subscriptionMiddleLabel} ${productCountNeeded} ${subscriptionEndLabel}`
      //subscriptionAriaLabel = `${subscriptionLabel} ${minOffer}% to ${maxOffer}%`
    }
    return {
      showSubscriptionOffer,
      subscriptionOfferLabel,
    }
  }

  renderIcon = isOpen => {
    return !isOpen ? (
      <Icons
        name="CRUD"
        icontype="plus"
        alt={i18nTranslate('icons.plus', 'plus icon', {
          nameSpace: 'ssr-resource',
        })}
        title={i18nTranslate('icons.plus', 'plus icon', {
          nameSpace: 'ssr-resource',
        })}
      />
    ) : (
      <Icons
        name="CRUD"
        icontype="minus"
        alt={i18nTranslate('icons.minus', 'minus icon')}
        title={i18nTranslate('icons.minus', 'minus icon')}
      />
    )
  }
  renderAccordion = (section = {}, index = 0) => {
    const { title = '', view = '' } = section
    if (view) {
      return (
        <AccordionBlock
          isActive={this.openAccordion}
          onClick={() => (this.openAccordion = !this.openAccordion)}
          key={index}
          renderIcon={this.renderIcon}
          textClass="about-title d-flex"
          title={title}>
          {view}
        </AccordionBlock>
      )
    } else {
      return ''
    }
  }

  handleProductDeleteCheckbox = (itemId, pv) => {
    // to handle single product select/deselect scenario
    if (subscriptionContainer.selectedSubscriptionProducts.has(itemId)) {
      subscriptionContainer.selectedSubscriptionProducts.delete(itemId)
      subscriptionContainer.selectedProductsTotalPV = Math.abs(
        subscriptionContainer.selectedProductsTotalPV - pv
      )
    } else {
      subscriptionContainer.selectedSubscriptionProducts.add(itemId)
      subscriptionContainer.selectedProductsTotalPV = Math.abs(
        subscriptionContainer.selectedProductsTotalPV + pv
      )
    }
  }

  handleDeleteAllCheckbox = subscriptionProducts => {
    // to select/deselect all product in month
    if (subscriptionContainer.selectedSubscriptionProducts.size) {
      // if selectedSubscriptionProducts has products already, then it must be deselected onClick
      subscriptionContainer.selectedSubscriptionProducts.clear()
      subscriptionContainer.selectedProductsTotalPV = 0.0
    } else {
      // if there are no products in selectedSubscriptionProducts,
      // then on selecting checkBox, all products must be added to selectedSubscriptionProducts
      subscriptionProducts?.forEach((item, index) => {
        const itemId = item?.id || 0
        const pv = parseFloat(item?.properties?.pointValue || '00.00')
        subscriptionContainer.selectedSubscriptionProducts.add(itemId)
        subscriptionContainer.selectedProductsTotalPV = Math.abs(
          subscriptionContainer.selectedProductsTotalPV + pv
        )
      })
    }
  }

  handleMultipleDelete = async (screenName = '') => {
    this.isDeleteAllCallInProgress = true
    overlayState.toggleLoader()
    const response = await subscriptionContainer.deleteSubscriptionProducts(
      subscriptionContainer.selectedSubscriptionProducts,
      screenName
    )
    const isPvAssistantEnable =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistEnabled ||
      false
    const pvAssistGoal =
      subscriptionContainer.subscriptionPreferenceResponse?.pvAssistGoal || '0'
    const orders =
      subscriptionContainer.subscriptionPreferenceResponse?.order || {}
    const data = response?.subscriptions || 0
    let itemPV = 0.0
    data?.length > 0 &&
      data?.map(
        (item, index) =>
          (itemPV = parseFloat(item?.properties?.pointValue) + itemPV)
      )

    const minMonthlyPV = orders?.monthlyPV || '0'
    const pvDifference = minMonthlyPV - itemPV

    if (subscriptionContainer.isSuccessResponse(response)) {
      if (screenName === 'pvAssistPage') {
        await this.getPvAssistanceResponse()
        if (subscriptionContainer.selectedPvItems.length > 0) {
          let postData = []
          let pvItemSubscriptions = [...subscriptionContainer.selectedPvItems]
          pvItemSubscriptions =
            pvItemSubscriptions.length > 0 && sortingPvItem(pvItemSubscriptions)
          pvItemSubscriptions.forEach((item, index) => {
            let formingData = {
              id: item?.id,
              itempriority: index + 1,
            }
            return postData.push(formingData)
          })
          await subscriptionContainer.patchPvAssistItems(
            customerContainer.userId,
            postData
          )
        }
      } else {
        isPvAssistantEnable &&
          pvDifference !== 0 &&
          pvDifference < pvAssistGoal &&
          this.renderPvModal()
        if (customerContainer.isRegisterUser)
          await cartContainer.getSubscriptionCount()
        await this.getSubscriptionResponse()
      }
    }
    overlayState.toggleLoader()
    this.isDeleteAllCallInProgress = false
  }

  handleCancelDelete = () => {
    this.enableConfirmation = false
  }

  handleConfirmDelete = () => {
    this.enableConfirmation = false
    this.handleMultipleDelete()
  }

  handleDeleteAllItem = () => {
    const productStr = []
    let remainArray = []
    if (subscriptionContainer.selectedSubscriptionProducts.size != 0) {
      subscriptionContainer.selectedSubscriptionProducts.forEach(productId => {
        return productStr.push(productId)
      })
      remainArray = subscriptionContainer.selectedSubscription.filter(item => {
        return !productStr.includes(item.id)
      })
    }
    let hasOneTime =
      remainArray.some(data => data?.type === 'VARIABLE_SINGLE_ORDER') || false
    let hasMultiTime =
      remainArray.some(data => data?.type === 'VARIABLE_MULTI_ORDER') || false
    if (remainArray.length === 0 || hasMultiTime) {
      this.enableConfirmation = true
    } else {
      this.isDeleteModalEnabled = true
    }
  }
  highlightSelectedProduct = selectedSkuID => {
    this.selectedSkuID = selectedSkuID
  }

  renderGift = gift => {
    const { imageUrl, skuName, variant } = gift

    return (
      <div className="prod-tile-container">
        <div className="d-flex w-100">
          <div
            className={`prod-image-wrapper w-100 h-100 ${
              application.isMobile ? '' : 'gift-image-wrapper'
            }`}>
            <Image
              src={application.getResponsiveImage({
                src: imageUrl,
              })}
              alt={skuName}
              className="prod-img"
            />
          </div>

          {application.isMobile ? (
            <div className="prod-desc-wrapper">
              <div className="prod-desc-title text-capitalize">
                {`${skuName}${variant ? ' - ' + variant : ''}`}
              </div>
              <div className="d-flex flex-column">
                <div>$0.00</div>
                <div className="d-flex flex-row justify-content-between">
                  <div className="gift-item-text-with-border">
                    {i18nTranslate(
                      'cartAndOrderHistory.staticGiftText',
                      'Free Gift'
                    )}
                  </div>
                  <div className=" text-uppercase align-self-center">
                    {i18nTranslate('review.quantityTitle', 'qty')}: 1
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="prod-desc-wrapper d-flex w-100 justify-content-between">
              <>
                <div className="prod-desc-title text-capitalize">
                  {`${skuName}${variant ? ' - ' + variant : ''}`}
                </div>
                <div className=" text-right d-flex flex-column justify-content-between gift-right-section">
                  <div>$0.00</div>

                  <div className="gift-item-text-with-border">
                    {i18nTranslate(
                      'cartAndOrderHistory.staticGiftText',
                      'Free Gift'
                    )}
                  </div>

                  <div className=" text-uppercase">
                    {i18nTranslate('review.quantityTitle', 'qty')}: 1
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
      </div>
    )
  }
  renderGiftBlock = promo => {
    const promotionPVGiftProperties = promo?.promotionPVGiftProperties || []
    const promotionPV = parseFloat(promo?.promotionPointValue || 0)
    const orders =
      subscriptionContainer.subscriptionPreferenceResponse?.order || []
    const PV = orders?.monthlyPV || '0'
    const currentPV = parseFloat(PV)
    if (currentPV >= promotionPV && promotionPVGiftProperties?.length > 0) {
      return promotionPVGiftProperties?.map(this.renderGift)
    }
  }
  renderCurrentGifts = (selectedMonth, currentMonth) => {
    const giftResponse = subscriptionContainer.subscriptionPromoResponse
    if (
      !giftResponse ||
      !giftResponse.length ||
      selectedMonth != currentMonth
    ) {
      return ''
    }
    return giftResponse.map(this.renderGiftBlock)
  }

  renderSubscriptionFreeGifts = (isGiftAvailable, isGiftArray) => {
    return (
      isGiftAvailable &&
      isGiftArray?.map(freeGift => {
        const freeGiftImg =
          freeGift?.skus?.[0]?.skuProperties?.primaryimage || imagePlaceholder
        const freeGiftName = freeGift?.skus?.[0]?.name || ''
        return (
          <>
            <div className="product-box">
              <div className="free-gift-pdp-cont1">
                <div className={`prod-image-wrapper`}>
                  <Image
                    src={freeGiftImg}
                    alt={freeGiftName}
                    className={`prod-img`}
                    data-testid="qa-user-sub-product-free-gift-image"
                  />
                </div>
                <p
                  className="prod-desc-title text-capitalize paragraph-m"
                  data-testid="qa-user-sub-product-name">
                  {freeGiftName}
                </p>
              </div>
            </div>
          </>
        )
      })
    )
  }

  renderSubscriptionProducts = month => {
    const subscriptionProductsOriginal =
      subscriptionContainer.selectedSubscription
    let subscriptionProducts = []
    if (Array.isArray(subscriptionProductsOriginal)) {
      subscriptionProducts = subscriptionContainer?.selectedSubscription.filter(
        sub => !sub.enableItemLevelProcessing
      )
    }
    const {
      // orderProcessingDate = '',
      // freezeOrderDate = '',
      lastOrderProcessingDate = '',
      // currentDate = '',
      currentDateInMillis = '',
    } = subscriptionContainer.subscriptionPreferenceResponse

    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    const { showSubscriptionOffer, subscriptionOfferLabel } =
      this.subscriptionOfferMessage()
    // const startMonth = subscriptionContainer.subscriptionPreferenceResponse?.startMonth
    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0

    // const lastOrderProcessedMonth = new Date(lastOrderProcessingDate).getMonth()
    // EC-8402 - currentDate format is not supported by Safari 13.1.
    // And so, using the new node 'currentDateInMillis',
    // 'currentDateInMillis' is in timestamp format
    // const currentMonth = new Date(parseUTCDate(currentDate || '')).getMonth()
    // const currentMonth = new Date(currentDateInMillis).getMonth()
    // const lastOrderMonth = new Date(lastOrderProcessingDate).getMonth() + 1
    // ^unused @todo @vetri check and remove
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)
    const lastOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const isToDisableEdit =
      lastOrderMonth == selectedMonth &&
      lastOrderStatus.toLowerCase() == 'order_created'
    // If currentMonth Order Deleted, then it can be reprocessed
    // if reprocessing enabled for current Month,
    // except Payment all other options(like frequency, quantity) must be disabled
    const enableQuantityAndFrequencyEdit = !isToDisableEdit

    const totalSubscriptionProduct =
      cartContainer.subscriptionResponse?.totalSubscriptionCount || 0
    let subscriptionProductsCount = subscriptionProducts?.length
    let selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts?.size
    const isToSelectDeleteAll = selectedProductCount != 0 ? true : false
    const deleteAllMessage = i18nTranslate(
      'mysubscriptions.deleteAllProducts',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )
    const deleteAllTitle = i18nTranslate(
      'subscription.deleteAllTitle',
      'Delete All Subscriptions'
    )
    const deleteProductsMessage = i18nTranslate(
      'mysubscriptions.deleteProductsMessage',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )
    const confirmDeleteAllProductsTitle = i18nTranslate(
      'mysubscriptions.confirmDeleteAllProductsTitle',
      'Are you sure ?'
    )
    const confirmDeleteAllProductsDesc = i18nTranslate(
      'mysubscriptions.confirmDeleteAllProductsDesc',
      'If you want to cancel your subscription, click on “CANCEL SUBSCRIPTION” on the subscription page.'
    )
    // const closeButton = i18nTranslate('mysubscriptions.closeButton', 'Close')
    const deleteProductsTitle =
      selectedProductCount == 1
        ? `${i18nTranslate('catalog.Delete', 'Delete', {
            nameSpace: 'ssr-resource',
          })} ${selectedProductCount} ${i18nTranslate('catalog.Item', 'item', {
            nameSpace: 'ssr-resource',
          })} ?`
        : `${i18nTranslate('catalog.Delete', 'Delete', {
            nameSpace: 'ssr-resource',
          })} ${selectedProductCount} ${i18nTranslate(
            'catalog.Items',
            'items',
            {
              nameSpace: 'ssr-resource',
            }
          )} ?`
    // logic for showing message inside delete confirmation pop-up
    // single delete scenarios (using icon in each product):
    //    if monthly pv after delete < 50 ->"UNDER 50PV MINIMUM" text will be shown
    //    else -> "are your sure ..." text will be shown
    // multiple delete scenarios (using checkbox):
    //    if all items are selected -> "delete all subscriptions?" text will be shown
    //    if monthly pv after delete < 50 -> "UNDER 50PV MINIMUM" text will be shown
    //    else -> "delete 1 item" or "delete x items" text will be shown
    let deleteModalMessage =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllMessage
        : deleteProductsMessage

    let deleteModalTitle =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllTitle
        : deleteProductsTitle

    const selectedItemTitle =
      subscriptionProductsCount == 1
        ? i18nTranslate('catalog.Item', 'item', {
            nameSpace: 'ssr-resource',
          })
        : i18nTranslate('catalog.Items', 'items', {
            nameSpace: 'ssr-resource',
          })
    const selectedProducts = `${selectedProductCount} ${i18nTranslate(
      'mysubscriptions.selectedProducts',
      ' selected'
    )}`

    const shippingMethods =
      subscriptionContainer.subscriptionPreferenceResponse?.shippingMethods ||
      []
    const payment =
      subscriptionContainer.subscriptionPreferenceResponse?.payment || {}
    let unavailableItems = []
    return (
      <>
        {subscriptionProducts.length > 0 &&
          subscriptionProducts.map((item, index) => {
            const productStatus = item?.itemInfo?.[0]?.skus?.[0]?.status
            const productSkuId = item?.itemInfo?.[0]?.skus?.[0]?.id
            const isSubscription =
              item?.itemInfo?.[0]?.properties?.issubscription || ''
            // Show 'Out of stock' and 'In active' products in month tab ofsubscription dashboard
            const isProductStatusInactive =
              productStatus?.toLowerCase() === 'inactive' ||
              isSubscription === false
            const stockStatus = (
              item?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
            ).toLowerCase()
            const isStockError =
              stockStatus === 'out of stock' || stockStatus === 'discontinued'
            const type = item?.itemInfo?.[0]?.skus?.[0]?.type?.toLowerCase()
            const inventoryStatus =
              item?.itemInfo?.[0]?.skus?.[0]?.inventory?.toLowerCase()
            const oos =
              (inventoryStatus === 'out of stock' &&
                type != 'skukit' &&
                type != 'bundle' &&
                type != 'fixedbundle') ||
              ''
            const bundleItems = subscriptionContainer.getBundleData(item)
            const usersSubscritions = month === 'allusers'

            const renderSection = (
              <>
                <SubscriptionProductTile
                  data={item}
                  key={productSkuId}
                  isStockError={isStockError}
                  isProductStatusInactive={isProductStatusInactive}
                  handleFrequencyChange={this.handleFrequencyChange}
                  handleQuantityChange={this.handleQuantityChange}
                  handleCancelItem={this.cancelSubscription}
                  handleSkipItem={this.handleSkipItem}
                  handleItemProcessing={this.handleItemProcessing}
                  currencySign={currencySign}
                  bundleItems={bundleItems}
                  shippingMethods={shippingMethods}
                  payment={payment}
                  disableNonActiveMonth={!enableQuantityAndFrequencyEdit}
                  totalSubscriptionCount={totalSubscriptionProduct}
                  handleProductDelete={this.handleProductDeleteCheckbox}
                  isToDisableDeleteCheckbox={isToDisableEdit}
                  isProductAddedInSubscriptionScreen={
                    productSkuId === this.selectedSkuID ? true : false
                  }
                  disableActions={oos}
                  buyerUserSubscription={usersSubscritions}
                />
              </>
            )
            if (
              month !== 'allusers' &&
              isStockError &&
              stockStatus !== 'out of stock'
            ) {
              unavailableItems.push(renderSection)
              return ''
            }
            return renderSection
          })}

        {month !== 'allusers' &&
          this.renderCurrentGifts(selectedMonth, currentMonth)}
        {/* {month !== 'allusers' && this.renderRemovedSection(unavailableItems)} */}
      </>
    )
  }

  renderSubscriptionLegacyProducts = (month, subscriptionProducts) => {
    // let subscriptionProducts = this.checkLegacySubscriptions()

    const {
      // orderProcessingDate = '',
      // freezeOrderDate = '',
      lastOrderProcessingDate = '',
      // currentDate = '',
      currentDateInMillis = '',
    } = subscriptionContainer.subscriptionPreferenceResponse || {}

    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    const { showSubscriptionOffer, subscriptionOfferLabel } =
      this.subscriptionOfferMessage()
    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    // const lastOrderProcessedMonth = new Date(lastOrderProcessingDate).getMonth()
    // EC-8402 - currentDate format is not supported by Safari 13.1.
    // And so, using the new node 'currentDateInMillis',
    // 'currentDateInMillis' is in timestamp format
    // const currentMonth = new Date(parseUTCDate(currentDate || '')).getMonth()
    // const currentMonth = new Date(currentDateInMillis).getMonth()
    // const lastOrderMonth = new Date(lastOrderProcessingDate).getMonth() + 1
    // ^unused @todo @vetri check and remove
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)
    const lastOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const isToDisableEdit =
      lastOrderMonth == selectedMonth &&
      lastOrderStatus?.toLowerCase() == 'order_created'
    // const enableQuantityAndFrequencyEdit = isSubscriptionEditable(
    //   currentMonth,
    //   selectedMonth,
    //   lastOrderProcessedMonth
    // )

    // If currentMonth Order Deleted, then it can be reprocessed
    // if reprocessing enabled for current Month,
    // except Payment all other options(like frequency, quantity) must be disabled
    const enableQuantityAndFrequencyEdit = !isToDisableEdit

    const totalSubscriptionProduct =
      cartContainer.subscriptionResponse?.totalSubscriptionCount || 0
    let subscriptionProductsCount = subscriptionProducts?.length
    let selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts?.size
    const isToSelectDeleteAll = selectedProductCount != 0 ? true : false
    /* const orders = 
      subscriptionContainer.subscriptionPreferenceResponse?.order
     */
    //const minMonthlyPV = orders?.monthlyPV || '0'
    //const pv = '60.00'
    //let pvTitle = i18nTranslate('subscription.pvTitle', 'UNDER 50PV MINIMUM')
    /*let pvMessage = i18nTranslate(
      'subscription.pvMessage',
      'Would you like to proceed?'
    )*/
    const deleteAllMessage = i18nTranslate(
      'mysubscriptions.deleteAllProducts',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )
    const deleteAllTitle = i18nTranslate(
      'subscription.deleteAllTitle',
      'Delete All Subscriptions'
    )
    const deleteProductsMessage = i18nTranslate(
      'mysubscriptions.deleteProductsMessage',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )
    const confirmDeleteAllProductsTitle = i18nTranslate(
      'mysubscriptions.confirmDeleteAllProductsTitle',
      'Are you sure ?'
    )
    const confirmDeleteAllProductsDesc = i18nTranslate(
      'mysubscriptions.confirmDeleteAllProductsDesc',
      'If you want to cancel your subscription, click on “CANCEL SUBSCRIPTION” on the subscription page.'
    )
    // const closeButton = i18nTranslate('mysubscriptions.closeButton', 'Close')
    const deleteProductsTitle =
      selectedProductCount == 1
        ? `Delete ${selectedProductCount} item ?`
        : `Delete ${selectedProductCount} items ?`
    // logic for showing message inside delete confirmation pop-up
    // single delete scenarios (using icon in each product):
    //    if monthly pv after delete < 50 ->"UNDER 50PV MINIMUM" text will be shown
    //    else -> "are your sure ..." text will be shown
    // multiple delete scenarios (using checkbox):
    //    if all items are selected -> "delete all subscriptions?" text will be shown
    //    if monthly pv after delete < 50 -> "UNDER 50PV MINIMUM" text will be shown
    //    else -> "delete 1 item" or "delete x items" text will be shown
    let deleteModalMessage =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllMessage
        : deleteProductsMessage

    let deleteModalTitle =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllTitle
        : deleteProductsTitle

    const selectedItemTitle =
      subscriptionProductsCount == 1
        ? i18nTranslate('catalog.Item', 'item', {
            nameSpace: 'ssr-resource',
          })
        : i18nTranslate('catalog.Items', 'items', {
            nameSpace: 'ssr-resource',
          })
    const selectedProducts = `${selectedProductCount} ${i18nTranslate(
      'mysubscriptions.selectedProducts',
      ' selected'
    )}`

    const shippingMethods =
      subscriptionContainer.subscriptionPreferenceResponse?.shippingMethods ||
      []
    const payment =
      subscriptionContainer.subscriptionPreferenceResponse?.payment || {}
    let unavailableItems = []
    return (
      <>
        {subscriptionProducts?.length > 0 &&
          subscriptionProducts?.map((item, index) => {
            const productStatus = item?.itemInfo?.[0]?.skus?.[0]?.status
            const productSkuId = item?.itemInfo?.[0]?.skus?.[0]?.id
            const isSubscription =
              item?.itemInfo?.[0]?.properties?.issubscription
            const isProductStatusInactive =
              productStatus?.toLowerCase() === 'inactive' ||
              isSubscription === false
            const stockStatus = (
              item?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
            ).toLowerCase()
            const isStockError =
              stockStatus === 'out of stock' || stockStatus === 'discontinued'
            const oos =
              item?.itemInfo?.[0]?.skus?.[0]?.inventory?.toLowerCase() ===
                'out of stock' || ''
            const bundleItems = subscriptionContainer.getBundleData(item)
            const usersSubscritions = month === 'allusers'

            const renderSection = (
              <>
                <SubscriptionProductTileLegacy
                  data={item}
                  key={productSkuId}
                  isStockError={isStockError}
                  isProductStatusInactive={isProductStatusInactive}
                  handleFrequencyChange={this.handleFrequencyChange}
                  handleQuantityChange={this.handleQuantityChange}
                  handleCancelItem={this.cancelSubscription}
                  handleSkipItem={this.handleSkipItem}
                  handleItemProcessing={this.handleItemProcessing}
                  currencySign={currencySign}
                  bundleItems={bundleItems}
                  shippingMethods={shippingMethods}
                  payment={payment}
                  // selectedMonth={selectedMonth}
                  // currentMonth={currentMonth}
                  // lastOrderProcessedMonth={lastOrderProcessedMonth}
                  // lastOrderProcessingDate={lastOrderProcessingDate}
                  disableNonActiveMonth={!enableQuantityAndFrequencyEdit}
                  totalSubscriptionCount={totalSubscriptionProduct}
                  handleProductDelete={this.handleProductDeleteCheckbox}
                  isToDisableDeleteCheckbox={isToDisableEdit}
                  isProductAddedInSubscriptionScreen={
                    productSkuId === this.selectedSkuID ? true : false
                  }
                  disableActions={oos}
                  buyerUserSubscription={usersSubscritions}
                />
              </>
            )
            if (
              month !== 'allusers' &&
              isStockError &&
              stockStatus !== 'out of stock'
            ) {
              unavailableItems.push(renderSection)
              return ''
            }
            return renderSection
          })}

        {month !== 'allusers' &&
          this.renderCurrentGifts(selectedMonth, currentMonth)}
        {/* {month !== 'allusers' && this.renderRemovedSection(unavailableItems)} */}
      </>
    )
  }

  renderRemovedSection = removedItems => {
    return (
      removedItems.length > 0 && (
        <div className="removed-items-section">
          <div className="removed-items-title">
            {i18nTranslate('subscription.removed', 'Removed')}
          </div>

          <div>{removedItems}</div>
        </div>
      )
    )
  }
  renderSubscriptionProductsView = () => {
    const subscriptionProductsOriginal =
      subscriptionContainer.selectedSubscription
    let subscriptionProducts = []
    if (Array.isArray(subscriptionProductsOriginal)) {
      subscriptionProducts = subscriptionProductsOriginal.filter(
        sub => !sub.enableItemLevelProcessing
      )
    }
    const { lastOrderProcessingDate = '', currentDateInMillis = '' } =
      subscriptionContainer.subscriptionPreferenceResponse || {}

    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)
    const lastOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const isToDisableEdit =
      lastOrderMonth == selectedMonth &&
      lastOrderStatus.toLowerCase() == 'order_created'
    const totalSubscriptionProduct =
      cartContainer.subscriptionResponse?.totalSubscriptionCount || 0
    let subscriptionProductsCount = subscriptionProducts?.length
    let selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts?.size
    const isToSelectDeleteAll = selectedProductCount != 0 ? true : false
    const deleteAllMessage = i18nTranslate(
      'mysubscriptions.deleteAllProducts',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )
    const deleteAllTitle = i18nTranslate(
      'subscription.deleteAllTitle',
      'Delete All Subscriptions'
    )
    const deleteProductsMessage = i18nTranslate(
      'mysubscriptions.deleteProductsMessage',
      'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
    )

    let deleteText = i18nTranslate('cart.delete', 'Delete')
    const deleteProductsTitle =
      selectedProductCount == 1
        ? `${deleteText} ${selectedProductCount} ${i18nTranslate(
            'catalog.Item',
            'Item',
            {
              nameSpace: 'ssr-resource',
            }
          )}`
        : `${deleteText} ${selectedProductCount} ${i18nTranslate(
            'catalog.Items',
            'Items',
            {
              nameSpace: 'ssr-resource',
            }
          )}`
    let deleteModalMessage =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllMessage
        : deleteProductsMessage

    let deleteModalTitle =
      subscriptionProductsCount === selectedProductCount
        ? deleteAllTitle
        : deleteProductsTitle

    const selectedItemTitle =
      subscriptionProductsCount == 1
        ? i18nTranslate('catalog.Item', 'item', {
            nameSpace: 'ssr-resource',
          })
        : i18nTranslate('catalog.Items', 'items', {
            nameSpace: 'ssr-resource',
          })
    const selectedProducts = `${selectedProductCount} ${i18nTranslate(
      'mysubscriptions.selectedProducts',
      ' selected'
    )}`
    const paramMonth = subscriptionContainer.allUsers
      ? 'allusers'
      : this.props.location?.queryParams?.month || ''
    /*const isGiftAvailable =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.gifts?.length > 0
    const isGiftArray =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.gifts || []*/

    const subscriptionProductsView = this.renderSubscriptionProducts(paramMonth)
    /*const subscriptionFreeGiftsView = this.renderSubscriptionFreeGifts(
      isGiftAvailable,
      isGiftArray
    )*/

    return (
      <>
        <div className="d-flex delete-all-wrap mb-3 w-100 justify-content-between">
          <div className="d-flex sub-check-box w-100 justify-content-between">
            <Form.Check
              //className="subs-delete-all-checkbox"
              className="subs-delete-month-checkbox"
              type="checkbox"
              label={
                isToSelectDeleteAll
                  ? i18nTranslate('mysubscriptions.unSelect', 'Unselect')
                  : i18nTranslate('mysubscriptions.selectAll', 'Select All')
              }
              custom
              id={`subscription-month-product-checkbox-${currentMonth}`}
              checked={isToSelectDeleteAll}
              onChange={() =>
                this.handleDeleteAllCheckbox(subscriptionProducts)
              }
              disabled={isToDisableEdit}
            />
            <Button
              className={
                isToSelectDeleteAll ? 'delete_selected_button mr-4' : 'mr-4'
              }
              onClick={this.handleDeleteAllItem}
              disabled={
                !isToSelectDeleteAll ||
                isToDisableEdit ||
                this.isDeleteAllCallInProgress
              }
              data-testid="qa-user-subs-all-product-delete">
              {i18nTranslate('mysubscriptions.delSelected', 'Delete Selected')}
            </Button>
            {this.enableConfirmation && (
              <ConfirmationModal
                showConfirmationModal={this.enableConfirmation}
                handleConfirm={this.handleConfirmDelete}
                handleCancel={this.handleCancelDelete}
                handleHide={this.handleCancelDelete}
                modalMessage={deleteModalMessage}
                renderText={deleteModalTitle}
                totalSubscriptionLength={totalSubscriptionProduct}
                totalSubscriptionSelected={selectedProductCount}
                isToDisableConfirmButton={
                  subscriptionContainer.isDeleteSubsCallInProgress
                }
                isSubscriptionDelete={true}
                cancelButtonText={undefined}
                isAllSubscriptionsSelected={false}
              />
            )}
          </div>
        </div>
        <Row noGutters className="prodViewOverflow d-flex w-100 flex-wrap ">
          {subscriptionProductsView}
        </Row>
        {/* {isGiftAvailable && (
          <>
            <h2 className="heading-2 mt-3 mb-4">Free Gift on Your Purchase</h2>
            <Row
              noGutters
              className="subCartFreeGifts prodViewOverflow d-flex w-100 flex-wrap ">
              {subscriptionFreeGiftsView}
            </Row>
          </>
        )} */}
      </>
    )
  }
  renderSubscriptionLegacyProductsView = migratedSubscriptionProducts => {
    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const paramMonth = subscriptionContainer.allUsers
      ? 'allusers'
      : this.props.location?.queryParams?.month || ''

    const subscriptionProductsView = this.renderSubscriptionLegacyProducts(
      paramMonth,
      migratedSubscriptionProducts
    )

    return (
      <div className="legacyCard d-flex justify-content-between w-100 flex-wrap align-items-start">
        {subscriptionProductsView}
      </div>
    )
  }

  renderShow = user => {
    return (
      <ShowAll
        handleCancelItem={this.cancelSubscriptionAll}
        updateSubscription={this.getSubscriptionResponse}
        renderSubscriptionSavingsView={this.renderSubscriptionSavingsView}
        selectedUser={user}
        setProcessingMonth={this.setProcessingMonth}
        {...this.props}
      />
    )
  }

  renderSubscriptionSection = month => {
    let category = month
    const subscriptionProducts = subscriptionContainer.selectedSubscription

    switch (category) {
      case 'showall': {
        const showAllSubscriptionProducts =
          subscriptionContainer.showAllSubscriptionResponse
        return (
          <ShowAllProductListView
            handleFrequencyChange={this.handleFrequencyChange}
            handleQuantityChange={this.handleQuantityChange}
            handleMultipleProductsDelete={this.handleMultipleDelete}
            isDeleteAllCallInProgress={this.isDeleteAllCallInProgress}
            showAllSubscriptionProducts={showAllSubscriptionProducts}
          />
        )
      }
      case 'pvassistant': {
        const hasSubscription =
          cartContainer.subscriptionResponse?.isSubscriptionPreference || false
        if (
          getAppConfig().shouldShowPvAssit &&
          (subscriptionProducts?.length > 0 || hasSubscription)
        ) {
          return (
            <ShowPvProductList
              handlePvAssistance={this.getPvAssistanceResponse}
              handleFrequencyChange={this.handleFrequencyChange}
              handleQuantityChange={this.handleQuantityChange}
              handleMultipleProductsDelete={this.handleMultipleDelete}
              selectedPvItems={subscriptionContainer.selectedPvItems}
              subscriptionProducts={subscriptionProducts}
            />
          )
        }
        return <React.Fragment />
      }

      default:
        break
    }

    /**
     * @note
     * applicable for case `alluser`
     */
    if (subscriptionProducts?.length > 0) {
      return (
        <div
          className={`'subscription-product-view d-flex' ${
            application.isMobile ? 'justify-content-center' : ''
          }`}>
          <div
            className={
              !application.isMobile && subscriptionProducts?.length > 0
                ? 'right-section mr-3'
                : ''
            }></div>
          <div
            className={
              subscriptionProducts?.length
                ? 'left-section d-flex flex-wrap'
                : ''
            }>
            {this.renderSubscriptionProductsView()}
          </div>
        </div>
      )
    }

    return <React.Fragment />
  }

  subscriptionNotFound = () => {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center m-auto h-50">
        <p className="no-subscription-text">
          {i18nTranslate(
            'mysubscriptions.noSubscriptionFound',
            'No Subscriptions Found'
          )}
        </p>
        <Link to={pageNames.home} className="d-flex justify-content-end">
          <Button
            data-testid="qa-start-shopping"
            className="text-uppercase subscriptionNotFound-btn">
            {i18nTranslate('cart.startShopping', 'Start Shopping')}
          </Button>
        </Link>
      </div>
    )
  }

  navigateToTermsUrl = () => {
    if (IS_BROWSER) {
      const links = new FormInputLabels()
      window.open(links.retailCustomerLinks?.subscriptionAgreement)
    }
  }

  toggleMigrationModal = () => {
    this.isToShowMigrationModal = !this.isToShowMigrationModal
  }

  renderMigrationSubscriptionModal = () => {
    return (
      <Modal
        centered={true}
        className={`modal-wrapper p-0 migration-modal`}
        show={this.isToShowMigrationModal}
        onHide={this.toggleMigrationModal}
        dialogClassName="migration-subscription-dialog">
        <Modal.Header closeButton className={'border-bottom-0 p-0'} />
        <Modal.Body className="p-0">
          <span>
            {i18nTranslate(
              'subscription.migrationText1',
              'This subscription has a shipping address and/or payment information that may be different from your primary subscription.'
            )}
          </span>{' '}
          <span>
            {i18nTranslate(
              'subscription.migrationText2',
              'Unfortunately this subscription cannot be modifed however, you may add these items to your primary subscription and delete these migrated subscriptions.'
            )}
          </span>
        </Modal.Body>
      </Modal>
    )
  }

  renderPlaceHolder = () => {
    const products = Array(6).fill('product')
    const listItems = Array(6).fill('listItem')
    const listBlocks = Array(3).fill('list')
    return (
      <div className="placholder-custom subscription-items-container">
        <div className="ph-search-block mx-3 my-2"></div>
        <div className="ph-options-block mx-3 mt-2 my-2"></div>
        <div className="subscription-items-placeholder">
          <ProductsPlaceHolder
            columnType={{ xs: '12', sm: '12', md: '4', lg: '4' }}
            columnClassName="subscription-items mb-2 mxsdf-2"
            products={products}
          />
          <div className="sidebar-isLoading">
            {listBlocks.length > 0 &&
              listBlocks.map((list, i) => (
                <div className="listBlock" key={i}>
                  <div className="d-flex justify-content-between mt-3 mb-3">
                    <p className="w-40"></p>
                    <p className="w-25"></p>
                  </div>
                  {/* <p className="w-50"></p> */}
                  <ul>
                    {listItems.length > 0 &&
                      listItems.map((listItem, i) => (
                        <li className="my-2" key={i}></li>
                      ))}
                  </ul>
                  {/* <p className="w-40 m-0"></p> */}
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }

  renderSubscription = () => {
    const subscriptionProducts = subscriptionContainer.selectedSubscription
    const showAllSubscriptionProducts =
      subscriptionContainer.showAllSubscriptionResponse || []

    const apiStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.apiStatus
    const isServiceFailure =
      subscriptionContainer.subscriptionPreferenceResponse?.isServiceFailure ||
      false
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || ''
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const titleText = i18nTranslate('subscription.header', 'Subscriptions')
    const month = this.props.location?.queryParams?.month || ''

    const LegacyTitle = i18nTranslate(
      'subscription.migratedSubscriptions',
      'Migrated Subscriptions'
    )
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderMonth = getConvertedMonth(lastOrderProcessingDate, timeZone)
    const lastOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const constructedDate = new Date(lastOrderProcessingDate)

    const enableReprocessNow =
      lastOrderMonth == currentMonth &&
      lastOrderStatus.toLowerCase() == 'order_failed'

    // const isOrderProcessedButNotSucceeded =
    //   lastOrderMonth === currentMonth &&
    //   lastOrderStatus.toLowerCase() !== 'order_success'
    const currentDateTimeStamp =
      subscriptionContainer.subscriptionPreferenceResponse?.currentDate || ''
    const currentDate = new Date(currentDateTimeStamp).getDate()
    const orderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.orderProcessingDate || ''
    const orderProcessDateForDisplay = dateFormatDeps?.getOrdinalDateAsString(
      orderProcessingDate,
      currentMonth,
      lastOrderMonth
    )
    const isCurrentDateExceededProcessingDate =
      currentDate > orderProcessingDate
    const selectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const isCurrentMonthDisplayed = selectedMonth == currentMonth
    const showSubProcessError =
      isCurrentMonthDisplayed && isCurrentDateExceededProcessingDate
    // lastOrderStatus.toLowerCase() !== 'order_success'
    // (isCurrentDateExceededProcessingDate || isOrderProcessedButNotSucceeded)

    const hasSubscription =
      cartContainer.subscriptionResponse?.isSubscriptionPreference || false
    const subscriptionProductsOriginal =
      subscriptionContainer.selectedSubscription
    let legacyCheck = []
    if (Array.isArray(subscriptionProductsOriginal)) {
      legacyCheck = subscriptionProductsOriginal.filter(
        sub => sub.enableItemLevelProcessing
      )
    }
    const monthlyTotal =
      subscriptionContainer?.subscriptionPreferenceResponse?.order
        ?.monthlyTotal || ''
    const monthlyOrderTotal = monthlyTotal
      ? parseFloat(monthlyTotal)?.toFixed(2)
      : 0

    const user =
      this.userList?.length > 0 &&
      !(
        Object.keys(this.selectedUser) &&
        Object.keys(this.selectedUser).length > 0
      )
        ? this.userList?.[0]
        : this.selectedUser
    const isGiftAvailable =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.gifts?.length > 0
    const isGiftArray =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.gifts || []
    const isEmptyProduct =
      subscriptionProductsOriginal?.length <= 0 && month !== 'showall'
    let migratedSubscriptionProducts = this.checkLegacySubscriptions()

    // To check if there are any One-time subscriptions
    let processNowFlagsForOneTime = this.isProcessNowErrorForOTP() || {}

    return (
      <>
        {/* Error to be shown when all subs are One-time */}
        {processNowFlagsForOneTime?.toShowOTPError &&
          this.isToEnableOneTimeFrequency && (
            <SubscriptionErrorNotification
              case="OneTimeError"
              date={orderProcessDateForDisplay}
            />
          )}

        {/* Error to be shown when there's a processing error */}
        {showSubProcessError && (
          <SubscriptionErrorNotification
            case="ProcessError"
            date={orderProcessDateForDisplay}
          />
        )}

        {subscriptionContainer.ccExpiryFlag && (
          <SubscriptionErrorNotification case="CCExpired" />
        )}
        <div
          className="pt-2 d-flex subscription-header-top"
          data-testid="qa-user-sub-upcoming-delivery-months-heading">
          <h1 className="heading-1 m-0">{titleText}</h1>
        </div>
        {
          <>
            {showAllSubscriptionProducts?.length > 0 && (
              <div>
                {this.isToShowProcessNowModal &&
                  (monthlyOrderTotal ||
                    (storeContainer.getEnableZeroCheckout() &&
                      !monthlyOrderTotal)) && (
                    <ProcessNowModal
                      show={this.isToShowProcessNowModal}
                      onHide={this.toggleProcessingNowModal}
                      disable={this.processNowClicked}
                      viewallTotal={this.viewallTotal}
                      legacyCheck={legacyCheck.length > 0}
                      areAllOtp={processNowFlagsForOneTime}
                      processNow={(
                        isStoreCreditApplied,
                        appliedStoreCredit
                      ) => {
                        this.handleProcessingNow(
                          isStoreCreditApplied,
                          appliedStoreCredit,
                          enableReprocessNow
                        )
                      }}
                    />
                  )}
                {this.isToShowProcessNowModal &&
                  !monthlyOrderTotal &&
                  !storeContainer.getEnableZeroCheckout() &&
                  modalState.setModalMessage(
                    i18nTranslate(
                      'subscription.zeroCheckoutText',
                      'Zero value checkout is not allowed. Please update your subscription cart to proceed further.'
                    ),
                    i18nTranslate('modaView.buttonText', 'OK')
                  )}
                {this.isBundleView && (
                  <BundleView
                    isBundleView={this.isBundleView}
                    handleBundleView={this.handleBundleView}
                    details={{
                      productId: this.productId,
                      categoryId: this.categoryId,
                    }}
                  />
                )}
                <div className="w-100">
                  {/**
                   * @note FIX FOR - CX121-4174
                   * temporarily disabling the timeline
                   * as its for v2 release
                   */}
                  {/* {showAllSubscriptionProducts?.length > 0 && (
                      <MobileSubscriptionsDeliveryStatus
                        allSubscriptionProducts={showAllSubscriptionProducts}
                      />
                    )} */}
                  {/* {showAllSubscriptionProducts?.length > 0 && (
                      <div className="w-100 mb-5">
                        <div className="sub-timeline-header mt-4 mb-lg-4">
                          {i18nTranslate(
                            'subscriptions.timelineHeader',
                            'Subscription Deliveries'
                          )}
                        </div>
                        <SubscriptionsDeliveryStatus
                          allSubscriptionProducts={showAllSubscriptionProducts}
                        />
                      </div>
                    )} */}
                  <div className="sbs-filter-options w-100 d-flex my-4">
                    {!subscriptionContainer.isPreferenceAPIInProgress &&
                      !isServiceFailure &&
                      hasSubscription === true &&
                      month !== 'pvassistant' &&
                      !subscriptionContainer.allUsers && (
                        <SubscriptionInfiniteScroll
                          handleSubscription={this.getSubscriptionResponse}
                          selectedItemSkuId={this.highlightSelectedProduct}
                          handleBundleView={this.handleBundleView}
                        />
                      )}
                    {this.renderShow(user)}
                  </div>
                  <div
                    className={`sbs-list-wrapper d-flex pt-6 justify-content-between ${
                      month === 'showall' ? 'sbs-list-view' : 'sbs-grid-view'
                    }`}>
                    <div
                      className={`subscriptionsPrducts  ${
                        isEmptyProduct ? 'm-auto' : ''
                      } ${month === 'showall' ? 'w-75' : ''} `}>
                      {subscriptionContainer.subscriptionPreferenceResponse
                        .selectedSubscriptions &&
                        (apiStatus == 'failure' && isServiceFailure
                          ? this.renderSubscriptionError()
                          : this.renderSubscriptionSection(month))}
                      {isEmptyProduct && (
                        <div className="benefit-no-subscription text-center">
                          {i18nTranslate(
                            'subscription.noItemsToShip',
                            'There are no items scheduled to ship in'
                          )}{' '}
                          {this.processingMonth}.
                        </div>
                      )}
                    </div>
                    <div className="subscriptionsTxnDetails minWidth-22 pl-2 pl-lg-3 pl-xl-4">
                      {isGiftAvailable && (
                        <div className="d-flex justify-content-center">
                          <p
                            className="gift_card text-center w-auto"
                            style={{
                              fontSize: '16px',
                            }}>
                            {i18nTranslate(
                              'freegift.yourOrder',
                              'Free Gift(s) on Your Order',
                              {
                                nameSpace: 'ssr-resource',
                              }
                            )}
                          </p>
                          <OverlayTrigger
                            trigger="click"
                            placement="left"
                            rootClose={true}
                            overlay={subscriptionContainer.renderFreeGiftSubscriptionPopover(
                              isGiftArray
                            )}>
                            <InformationIcon
                              size="2rem"
                              className="giftInfo ml-2"
                              style={{
                                left: '0px',
                                bottom: '5px',
                                width: '25px',
                                cursor: 'pointer',
                              }}
                            />
                          </OverlayTrigger>
                        </div>
                      )}
                      {
                        <div className="d-inline-block w-100">
                          {this.renderSubscriptionSavingsView()}
                        </div>
                      }
                      <div>
                        {
                          <SubscriptionShippingDetailsView
                            handleCancelItem={this.cancelSubscriptionAll}
                            updateSubscription={this.getSubscriptionResponse}
                            renderSubscriptionSavingsView={
                              this.renderSubscriptionSavingsView
                            }
                            renderScanCardInfo={this.renderScanCardInfo}
                            selectedUser={user}
                            toggleCardExpiryStatus={this.toggleCardExpiryStatus}
                            {...this.props}
                          />
                        }
                      </div>
                      {hasSubscription && subscriptionProducts.length > 0 && (
                        <div className="mt-2">
                          {this.renderSubscriptionRewardsViewSummary()}
                        </div>
                      )}
                    </div>
                  </div>
                  <p className="heading-1 mt-2">
                    {migratedSubscriptionProducts.length > 0 ? LegacyTitle : ''}
                  </p>
                  <hr />
                  {migratedSubscriptionProducts.length > 0 && (
                    <Button
                      onClick={this.toggleMigrationModal}
                      className="p-0 m-0 mb-3 migration-link"
                      variant="link">
                      {i18nTranslate(
                        'subscription.migrationMessage',
                        "Why can't I modify this subscription?"
                      )}
                    </Button>
                  )}
                  {this.isToShowMigrationModal &&
                    this.renderMigrationSubscriptionModal()}
                  {this.renderSubscriptionLegacyProductsView(
                    migratedSubscriptionProducts
                  )}
                  {this.isInfoModalEnabled && this.renderScanInfoModal()}
                  {this.isDeleteModalEnabled && this.renderDeleteInfoModal()}
                  <div>
                    <p>
                      <u
                        onClick={() => this.navigateToTermsUrl()}
                        role="button">
                        {i18nTranslate(
                          'editSubscription.TermsConditions',
                          'Subscription Terms and Conditions'
                        )}
                      </u>
                    </p>
                  </div>
                </div>
              </div>
            )}
            {showAllSubscriptionProducts?.length === 0 &&
              this.subscriptionNotFound()}
          </>
        }
        {/* </div> */}
      </>
    )
  }

  render() {
    const myAccountSubscription = i18nTranslate(
      'myAccountSubscriptionsPage.title',
      'Subscriptions | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountSubscription}
          imageUrl=""
          imageAlt=""
          description={i18nTranslate('myAccount.desc', 'My Account page')}
          location={this.props}
        />
        <div
          className="subscription-container p-lg-4 p-md-0 px-md-2 h-100"
          data-testid="qa-subscriptions-container">
          {subscriptionContainer.isPreferenceCallOver
            ? this.renderSubscription()
            : this.renderPlaceHolder()}
        </div>
      </>
    )
  }
}

export default SubscriptionsView1
export { SubscriptionsView1 }
